import React, {Children, createContext, forwardRef, useContext, useEffect, useMemo, useRef, useState} from 'react'
import {useCallingCode, useIntlEx} from "./IntlUtils";
import {useSolv} from "./SolvProvider";
import {PageDialog, PageDialogContainer, PageDialogMainPanel} from "./PageDialog";
import {useHistory, useLocation} from "react-router-dom";
import {showError, validateUrl} from "./ValidationUtils";
import {shortIdEqual} from "./StringUtils";
import {parsePathname} from "./UrlUtils";
import {booleanProp, isNullOrUndefined} from "./ReactUtils";
import {TagLabel} from "./TagBox";
import useStateRef from "react-usestateref";
import getLogger from "./Logging.js"
import {cssStringToObject, onlyDigits} from "./Utils";
import '../App.css'
import styles from "./FormComps.module.css"

const log = getLogger("FormComps")

export function useBusySpinner(props) {

  const { intl } = useIntlEx()

  const [busy, setBusy] = useState(null)

  function BusySpinner(props) {
    return (
      <div className={styles.busy_spinner} style={{display: (busy ? "flex" : "none")}}>
        <div className={styles.busy_spinner_body}>
          <img src="/images/spinner-white.svg"/>
          {
            busy && (
              "boolean" === typeof(busy) ? (
                intl.msg("loading")
              ) : (
                busy
              )
            )
          }
        </div>
      </div>
    )
  }

  return (
    {
      busy,
      setBusy,
      BusySpinner
    }
  )
}

export function useAlert(props) {

  const [alert, _setAlert] = useState(props ? props : null)
  function setAlert(a) {
    // // log.debug("setAlert: a=", a)
    _setAlert(a)
    if (a?.field) {
      showError(a.field, a.constraint || "required")
    }
  }

  return (
    [
      alert,
      setAlert
    ]
  )
}

export function Alert(props) {

  const {intl} = useIntlEx()

  // // log.debug(">>>Z: Alert: props=", props)

  let type, title, text

  if (props.alert) {
    type = props.alert.type?.toLowerCase() || "info"
    title = props.alert.title
    text = props.alert.text
  }
  else {
    type = props?.type?.toLowerCase() || "info"
    title = props?.title
    text = props?.text
  }

  if (!text) {
    return (<></>)
  }

  const align = props.align ? `talign-${props.align}` : "talign-left"

  const whitespace = props.whitespace ? `whitespace-${props.whitespace}` : ""

  return (
    (text || props.children) ? (
      <div className="d-flex justify-content-center align-items-center">
        <div className={props.className}>
          <div className={`${styles.alert_container} ${styles[`alert_${type}`]} ${align} ${whitespace}`} data-alert={type}>
            <div className={`${styles.alert_icon_container}`} data-alert={type}>
              <Icon name={type}/>
            </div>
            <div className={styles.alert_body_container} data-alert={type}>
              {
                title &&
                  <div className={`${styles.alert_title_container} ${align}`} data-alert={type}>
                    {title}
                  </div>
              }
              <div className={`${styles.alert_content_container} ${align}`} data-alert={type}>
                {
                  props.children ? (
                    <div>
                      {props.children}
                    </div>
                  ) : (
                    <div>{text}</div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <></>
    )
  )
}

export function AlertOld(props) {

  const {intl} = useIntlEx()

  let type, text, title
  if (props) {
    const types = Object.keys(props).filter(i => ["attn", "notice", "error", "fatal", "info", "success", "warn", "warning"].includes(i))
    // // log.debug(">>>Z: Alert: type=", type, typeof(props[type]), props.hasOwnProperty("text"))
    if (types.length > 0) {
      type = types[0]
      if (typeof(props[type]) === "object" && (props.hasOwnProperty("text"))) {
        text = props[type].text
        title = props[type].title
      }
      else {
        text = props[type]
      }
      if (type === "note") {
        type = "notice"
      }
      else if (type === "warn") {
        type = "warning"
      }
      // // log.debug(">>>Z: Alert: type, text, title=", type, text, title)
    }
    else if (props.fatal || props.error || props.warning || props.info || props.notice) {
      type = "warning"
      if (typeof(props.warning) === "object") {
        text = props.warning.text
        title = props.warning.title
      }
      else {
        text = props.warning
      }
    }
    else if (props.alert) {
      const alert = props.alert
      if (alert.type) {
        type = alert.type
        text = alert.text
        title = alert.title
      }
      else {
        const fields = ["notice", "fatal", "error", "info", "success", "warning"]
        const i = fields.findIndex((field) => alert.hasOwnProperty(field))
        type = fields[i]
        text = alert[fields[i]]
        title = alert.title
      }
    }
    else {
      type = props.type
      title = props.title
    }
  }
  const align = props.align ? `talign-${props.align}` : "talign-center"
  const whitespace = props.whitespace ? `whitespace-${props.whitespace}` : ""
  // log.debug(">>>Z: props=", props)
  return (
    (text || props.children) ? (
      <div className="d-flex justify-content-center align-items-center">
        <div className={props.className}>
          <div className={`${styles.alert_container} ${styles[`alert_${type}`]} ${align} ${whitespace}`} data-alert={type}>
            <div className={`${styles.alert_icon_container}`} data-alert={type}>
              <Icon name={type}/>
            </div>
            <div className={styles.alert_body_container} data-alert={type}>
              {
                title &&
                  <div className={`${styles.alert_title_container} ${align}`} data-alert={type}>
                    {title}
                  </div>
              }
              <div className={`${styles.alert_content_container} ${align}`} data-alert={type}>
                {
                  props.children ? (
                    <div>
                      {props.children}
                    </div>
                  ) : (
                    <div>{text}</div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <></>
    )
  )
}

export function FormHeader(props) {

  // const { width, height, ref } = useResizeDetector()

  return (
    <>
      <nav className={`${styles["form-header"]}`}>
      {/*<nav ref={ref} className={`${styles["form-header"]}`}>*/}
        {props.children}
      </nav>
      {/*<div className={styles["form-header-push"]} style={{height: height}}></div>*/}
    </>
  )

}

function FormHeaderToolbar(props) {
  return (
    <div className={styles["toolbar"]}>
      {props.children}
    </div>
  )
}

function FormHeaderToolbarTitle(props) {
  return (
    <div className={styles["title"]}>
      {props.children}
    </div>
  )
}

function FormHeaderToolbarControls(props) {
  return (
    <div className={styles["controls"]}>
      {props.children}
    </div>
  )
}

function FormHeaderAlerts(props) {
  return (
    (props.children && props.children.length > 0) ? (
      <>
        <div className={styles["divider"]}/>
        <center className={styles["alerts"]}>
          {props.children}
        </center>
      </>
    ) : (
      <></>
    )
  )
}

function FormHeaderSection(props) {
  return (
    props.children &&
      <div className={styles.section} style={{padding: "var(--form-header-padding-height)", borderTop: "1px solid var(--form-header-divider-color)"}}>
        {props.children}
      </div>
  )
}

function FormHeaderAlert(props) {
  // log.debug(">>>FormHeaderAlert=", props)
  return (
    props?.alert ? (
      <div style={{padding: "var(--form-header-padding-height)", borderTop: "1px solid var(--form-header-divider-color)"}}>
        <Alert {...props.alert}/>
      </div>
    ) : (
      <></>
    )
  )
}

function FormHeaderContent(props) {
  return (
    <>
      <div className={styles["divider"]}/>
      <div className={styles["content"]}>
        {props.children}
      </div>
    </>
  )
}

function FormHeaderTabs(props) {
  const tp = `tabs-position-${props.position ? props.position : "bottom"}`
  return (
    <>
      {
        props.title &&
          <div className={styles["tabs-title"]}>
            {props.title}
          </div>
      }
      {
        props.children &&
          <ul className={`${styles["tabs"]} ${styles[tp]}`} id={props.id ? props.id : ""} role="tablist">
            {props.children}
          </ul>
      }
    </>
  )
}

function handleTabClick(e) {

}

function FormHeaderTab(props) {
  const maxLength = 30
  var title = props.title || ""
  var alt = null
  if (title.length > maxLength) {
    alt = title
    title = title.slice(0, maxLength).trim() + "..."
  }

  return (
    <>
      <li key={props.key} className={styles["tab"]} role="presentation">
        <div className="d-flex align-items-center">
          {
            props.tag &&
            <TagLabel label={props.tag} size="sm" className={"mr-1"}/>
          }
          {
            props.image &&
              <img src={props.image} style={{width: "auto", height:"20px", outline: "none", marginRight: "6px", filter: (props.active === true ? "" : "grayscale(100%)")}}/>
          }
          <a className={`${styles["tab-link"]} ${(props.active === true) ? styles["active"] : ""}`} id={props.id ? props.id : ""} href={props.href} role="tab" aria-selected={props.active === true ? "true" : "false"} title={alt}>
            {
              title
            }
          </a>
        </div>
      </li>
    </>
  )
}

FormHeader.Toolbar = FormHeaderToolbar
FormHeader.Toolbar.Title = FormHeaderToolbarTitle
FormHeader.Toolbar.Controls = FormHeaderToolbarControls
FormHeader.Section = FormHeaderSection
FormHeader.Alerts = FormHeaderAlerts
FormHeader.Alert = FormHeaderAlert
FormHeader.Content = FormHeaderContent
FormHeader.Tabs = FormHeaderTabs
FormHeader.Tab = FormHeaderTab

export function FormBody(props) {
  return (
    <div className={`${styles["form-body"]} container-fluid`}>
      <div className="row">
        <div className="col">
          <form id={props.id || "frmMain"} autoComplete={props.autoComplete || "off"}>
            {props.children}
          </form>
        </div>
      </div>
    </div>
  )
}

function FormBodyDivider(props) {
  return (
    <div style={{margin: "28px 0 24px 0", borderTop: "1px solid var(--form-divider-color)"}}>
    </div>
  )
}

FormBody.Divider = FormBodyDivider

export function FormControl(props) {
  return (
    <></>
  )
}

function FormControlGroup(props) {
  return (
    <div className={`form-group ${booleanProp(props, "disabled") ? "readonly" : ""}`}>
      <div className="row">
        {props.children}
      </div>
    </div>
  )
}

function FormControlLabel(props) {
  let className = styles["form-label"]
  if (props.compact) {
    className = `${className} ${styles["form-label-compact"]}`
  }
  if (props.className) {
    className = `${className} ${props.className}`
  }
  return (
    <label className={className} htmlFor={props.htmlFor}>
      <p>
        <span className={styles["form-label-label"]}>{props.children}</span>
        <span className={styles["form-label-delimiter"]}>:</span>
      </p>
      {
        (props.subtitle || props.description) &&
          <div className="helptext">
            {props.subtitle || props.description}
          </div>
      }
    </label>
  )
}

FormControl.Group = FormControlGroup
FormControl.Label = FormControlLabel

const FormGroupsContext = createContext();

export function FormGroups(props) {

  const [collapsed, setCollapsed, collapsedRef] = useStateRef()
  const [collapsible, setCollapsible] = useState(false)

  useEffect(() => {
    if (props.collapsed !== undefined) {
      // log.debug(">>>Z: FormGroups: useEffect[props.collapsed]", props.id, props.collapsed)
      setCollapsed(props.collapsed);
      setCollapsible(true)
    }
  }, [props.collapsed]);

  const handleExpand = () => {
    setCollapsed(!collapsed)
  }

  let children = []

  if (!canCollapse()) {
    children = props.children
  }
  else {
    // children = Children.toArray(props.children)[0]
    children = !collapsedRef?.current ? props.children : <></>
  }

  function canCollapse() {
    // log.debug(">>>Z: FormGroups: canCollapse: ", props.id, typeof(collapsedRef?.current))
    // return collapsedRef?.current !== null && collapsed?.current !== undefined// && (props.title || props.text)
    return true === collapsible
  }

  return (
    <FormGroupsContext.Provider value={{props: props, collapsed: collapsed, handleExpand: handleExpand}}>
      {
        !booleanProp(props, "hidden") &&
          <div className={`form-groups ${props.formats ? props.formats : ""} ${canCollapse() ? (collapsedRef?.current ? "collapsible collapsed" : "collapsible expanded") : ""} ${booleanProp(props, "fillheight") ? "h-fill-height" : ""} ${props.className ? props.className : ""}`}>
            <div className="row">
              <div className="col">
                {
                  (props.title || props.text || props.description) &&
                    <div className="form-groups-header" onClick={canCollapse() ? handleExpand : null}>
                      <div className="form-groups-title">
                        {
                          (props.title || props.text) &&
                            <h1>{props.title || props.text}</h1>
                        }
                        {
                          props.description &&
                            <span className="helptext">{props.description}</span>
                        }
                      </div>
                      {
                        (true === collapsible) ? (
                          <div className="form-groups-collapse-button">
                            <Icon key="collapsible" name={collapsed ? "section_expand" : "section_collapse"}/>
                          </div>
                        ) : (
                          <></>
                        )
                      }
                    </div>
                }
                {children}
              </div>
            </div>
          </div>
      }
    </FormGroupsContext.Provider>
  )
}

function FormGroupsHeader(props) {
  return (
    <div className="form-groups-header">
      {props.children}
    </div>
  )
}

function FormGroupsHeaderTitle(props) {
  return (
    <div className="form-groups-title">
      {
        (props.title || props.text) &&
          <>
            <h1>{props.title || props.text}</h1>
            {
              props.description &&
                <span className="helptext">{props.description}</span>
            }
          </>
        }
    </div>
  )
}

function FormGroupsHeaderControls(props) {
  return (
    <div className="form-groups-controls">
      {props.children}
    </div>
  )
}

FormGroups.Header = FormGroupsHeader
FormGroups.Header.Title = FormGroupsHeaderTitle
FormGroups.Header.Controls = FormGroupsHeaderControls

const FormGroupContext = createContext();

export function FormGroup(props) {

  const [collapsed, setCollapsed] = useState(booleanProp(props, "collapsed"))

  useEffect(() => {
    if (props.collapsed !== undefined) {
      setCollapsed(props.collapsed);
    }
  }, [props.collapsed]);

  const handleExpand = () => {
    if (typeof(collapsed) === "boolean") {
      setCollapsed(undefined)
    }
  }

  let children = []

  if (undefined === collapsed || false === collapsed) {
    children = props.children
  }
  else {
    children = Children.toArray(props.children)[0]
  }

  let style = props.style

  let className = "form-group"

  if (booleanProp(props, "disabled")) {
    className = ` ${className} readonly`
  }

  if (booleanProp(props, "fillheight")) {
    className = ` ${className} h-fit-height`
  }

  if (true === collapsed) {
    className = ` ${className} collapsed`
  }

  if (props.className) {
    className = ` ${className} ${props.className}`
  }

  // `form-group ${booleanProp(props, "disabled") ? "readonly" : ""} ${true === collapsed ? "collapsed" : ""} ${props.className ? props.className : ""}`

  return (
    !booleanProp(props, "hidden") &&
      <FormGroupContext.Provider value={{props: props, collapsed: collapsed, handleExpand: handleExpand}}>
        <div key={props.key} className={className} style={style}>
          <div className="row">
            {children}
          </div>
        </div>
      </FormGroupContext.Provider>
  )
}

function FormGroupLabel(props) {
  const formGroupCtx = useContext(FormGroupContext);
  const collapsed = formGroupCtx?.collapsed
  const breakpoint = props.breakpoint ? `-${props.breakpoint}` : ""
  const cols = `-${props.cols || "12"}`
  return (
    <div className={`col${breakpoint}${cols}`}>
      <label className={`${styles["form-label"]} ${true === collapsed ? styles["form-label-collapsed"] : ""} ${props.compact ? styles["form-label-compact"] : ""} ${props.className || ""}`} htmlFor={props.htmlFor} onClick={undefined === collapsed ? null : formGroupCtx.handleExpand}>
        {
          props["placeholder-text"] ? (
            <span className={styles["form-label-label"]}>&nbsp;</span>
          ) : props.text ? (
            <p>
              <span className={styles["form-label-label"]}>{props.text}</span>
              {
                (undefined === collapsed || false === collapsed) ? (
                  <span className={styles["form-label-delimiter"]}>:</span>
                ) : (
                  <span className={styles["form-label-delimiter"]}>...</span>
                )
              }
            </p>
          ) : (
            <p>
              <span className={styles["form-label-label"]}>{props.children}</span>
              {
                (undefined === collapsed || false === collapsed) ? (
                  <span className={styles["form-label-delimiter"]}>:</span>
                ) : (
                  <span className={styles["form-label-delimiter"]}>...</span>
                )
              }
            </p>
          )
        }
        {
          (undefined === collapsed || false === collapsed) &&
            props["placeholder-description"] ? (
              <span className="helptext">&nbsp;</span>
            ) : (
              <span className="helptext">
                {props.subtitle || props.description}
                {
                  props.help &&
                    <a className="icon-link ml-2" title={props.help.tooltip || ""} href={`https://help.solv.technology/article/${props.help.slug}`} target="_blank">
                      <Icon name="question"/>
                    </a>
                }
              </span>
          )
        }
        {
          ("header" === props.type) && (undefined === collapsed || false === collapsed) &&
            <div style={{borderTop: "1px solid var(--form-divider-color)", marginTop: "0.5em", marginBottom: "1.12em"}}></div>
        }
      </label>
    </div>
  )
}

function FormGroupControl(props) {
  const breakpoint = props.breakpoint ? `-${props.breakpoint}` : ""
  const cols = `-${props.cols || "12"}`
  const className = `col${breakpoint}${cols} ${props.className || ""}`
  const style = props.style
  return (
    <div className={className} style={style}>
      {props.children}
    </div>
  )
}

function FormGroupControls(props) {
  const breakpoint = props.breakpoint ? `-${props.breakpoint}` : ""
  const cols = `-${props.cols || "12"}`
  const className = `col${breakpoint}${cols} ${props.className || ""}`
  const style = props.style
  return (
    <div className={className} style={style}>
      {props.children}
    </div>
  )
}

function FormGroupText(props) {
  const formGroupCtx = useContext(FormGroupContext);
  const breakpoint = props.breakpoint ? `-${props.breakpoint}` : ""
  const cols = `-${props.cols || "12"}`
  return (
    <div className={`col${breakpoint}${cols}`}>
      <label className={`${styles["form-label"]} ${props.compact ? styles["form-label-compact"] : ""} ${props.className || ""} mb-0`}>
        {
          props.text ? (
            <span className={styles["form-label-label"]}>{props.text}</span>
          ) : (
            <span className={styles["form-label-label"]}>{props.children}</span>
          )
        }
      </label>
    </div>
  )
}

FormGroup.Label = FormGroupLabel
FormGroup.Text = FormGroupText
FormGroup.Control = FormGroupControl
FormGroup.Controls = FormGroupControls

export function FormText(props) {
  const breakpoint = props.breakpoint ? `-${props.breakpoint}` : ""
  const cols = `-${props.cols || "12"}`
  const className = `col${breakpoint}${cols} ${props.className || ""}`
  return (
    <div className={className} style={{color: "var(--form-control-label-color)"}}>
      {
        props.text ? (
          props.text
        ) : (
          props.children
        )
      }
    </div>
  )
}

export function FormLabel(props) {
  const className = `form-control ${props.className || ""}`
  const style = props.style
  return (
    <label className={className} style={style}>
      {
        isBlankElement(props.children) ? (
          <>...</>
        ) : (
          <>{props.children}</>
        )
      }
    </label>
  )
}

function isBlankElement(e) {
  // console.log(">>>Z: isBlankElement: ", isNullOrUndefined(e), "number" === typeof(e), Number.isNaN(e), e)
  return (isNullOrUndefined(e) || ("number" === typeof(e) && Number.isNaN(e)))
}


export function BsRow(props) {
  if (booleanProp(props, "hidden")) {
    return (<></>)
  }
  let className = "row"
  if (booleanProp(props, "nowrap")) {
    className = `${className} flex-nowrap`
  }
  if (booleanProp(props, "nogutters")) {
    className = `${className} no-gutters`
  }
  if (booleanProp(props, "fillheight")) {
    className = `${className} h-fill-height`
  }
  if (props.className) {
    className = `${className} ${props.className}`
  }
  return (
    <div className={className}>{props.children}</div>
  )
}

export function BsCol(props) {
  if (booleanProp(props, "hidden")) {
    return (<></>)
  }
  let className = "col"
  if (props.breakpoint) {
    className = `${className}-${props.breakpoint}`
  }
  if (props.cols) {
    className = `${className}-${props.cols}`
  }
  if (props.order) {
    className = `${className} order-${props.order}`
  }
  if (booleanProp(props, "fillheight")) {
    className = `${className} h-fill-height`
  }
  if (props.className) {
    className = `${className} ${props.className}`
  }
  return (
    <div className={className}>{props.children}</div>
  )
}

export function Loading(props) {
  return (
    <div className={styles.loading}></div>
  )
}

export function MainContainer(props) {

  const {brandId, env, busy, fatal, setFatal} = useSolv()
  const {intl} = useIntlEx()

  useEffect(() => {
    if (props.tenant) {
      if (typeof(props.allowIf) === "boolean" && props.allowIf === false) {
          setFatal("INSUFFICIENT_PERMISSION")
      }
      if (props.allowIfAccessingAs) {
        if (props.tenant.accessingAs && !props.tenant.accessingAs(props.allowIfAccessingAs)) {
          setFatal("INSUFFICIENT_PERMISSION")
        }
      }
    }
  }, [props.tenant]);

  const fatalTypes = {
    DENIED_ACCESS: {
      title: intl.msg("fatal_error_access_denied_title"),
      description: intl.msg("fatal_error_access_denied_text"),
      iconClassName: "fas fa-ban text-warning",
      buttons: [{type: "SIGNIN", buttonClass: "btn-secondary"}]
    },
    INSUFFICIENT_PERMISSION: {
      title: intl.msg("fatal_error_access_denied_title"),
      description: intl.msg("fatal_error_access_denied_text"),
      iconClassName: "fas fa-ban text-warning",
      buttons: [{type: "SIGNIN", buttonClass: "btn-secondary"}]
    },
    UNAVAILABLE: {
      title: intl.msg("fatal_error_unavailable_title"),
      description: intl.msg("fatal_error_unavailable_text"),
      iconClassName: "fas fa-ban text-warning",
      buttons: [{type: "RETRY", buttonClass: "btn-secondary"}]
    },
    DISALLOWED: {
      title: intl.msg("fatal_error_disallowed_title"),
      description: intl.msg("fatal_error_disallowed_text"),
      iconClassName: "fas fa-ban text-warning",
      buttons: [{type: "RETRY", buttonClass: "btn-secondary"}]
    },
    NOT_FOUND: {
      title: intl.msg("fatal_error_not_found_title"),
      description: intl.msg("fatal_error_not_found_text"),
      iconClassName: "fas fa-question-circle text-warning",
      buttons: [{type: "BACK", buttonClass: "btn-secondary"}]
    },
    OOPS: {
      title: intl.msg("fatal_error_oops_title"),
      description: intl.msg("fatal_error_oops_text"),
      iconClassName: "fas fa-frown text-warning",
      buttons: [{type: "RETRY", buttonClass: "btn-secondary"}]
    }
  }

  function FatalError() {

    // log.debug(">>>Z: fatal=", JSON.stringify(fatal))

    let ft
    if (typeof(fatal) === "string") {
      ft = fatal
    }
    else if (fatal.type) {
      ft = fatal.type
    }
    else if (fatal.code) {
      switch (fatal.code) {
        case "UNAUTHORIZED":
        case "INSUFFICIENT_PERMISSION":
          ft = "DENIED_ACCESS"
          break
        case "NOT_FOUND":
          ft = "NOT_FOUND"
          break
        default:
          ft = "DENIED_ACCESS"
      }
    }
    else {
      ft = "OOPS"
    }
    let f
    if (ft in fatalTypes) {
      f = fatalTypes[ft]
    }
    else {
      f = fatalTypes["OOPS"]
    }

    return (
      fatal &&
        <PageDialogContainer className="mt-4 justify-content-start">
          <PageDialog size="md" align="center">
            <PageDialogMainPanel>
              <h1 style={{fontSize: "4.5rem"}}><i className={f.iconClassName}></i></h1>
              <h1 style={{fontSize: "3rem", marginBottom: "30px"}}>{f.title}</h1>
              <p className="lead">
                {f.description}<br/>
              </p>
              <div className="mt-4 d-flex flex-row">
                {
                  f.buttons.map ( button =>
                      <>
                        {
                          button.type == "BACK" ? (
                            <a className={`btn ${button.buttonClass} mr-1`} style={{fontSize: "1.171875rem"}} href="javascript:window.history.back()">{intl.msg("go_back")}</a>
                          ) : button.type == "RETRY" ? (
                            <a className={`btn ${button.buttonClass} mr-1`} style={{fontSize: "1.171875rem"}} href="javascript:window.location.reload()">{intl.msg("retry")}</a>
                          ) : button.type == "HOME" ? (
                            <a className={`btn ${button.buttonClass} mr-1`} style={{fontSize: "1.171875rem"}} href="/">{intl.msg("home")}</a>
                          ) : button.type == "SIGNIN" ? (
                            <a className={`btn ${button.buttonClass} mr-1`} style={{fontSize: "1.171875rem"}} href="/signin">{intl.msg("signin_as_another")}</a>
                          ) : (
                            <></>
                          )
                        }
                      </>
                  )
                }
                <a className={`btn btn-secondary`} style={{fontSize: "1.171875rem"}} href={`${env.HELP_ENDPOINT}`} target="_help">{intl.msg("help")}</a>
              </div>
            </PageDialogMainPanel>
          </PageDialog>
        </PageDialogContainer>
    )
  }

  return (
    <>
      <div className={styles.busy_spinner} style={{display: (busy ? "flex" : "none")}}>
        <div className={styles.busy_spinner_body}>
          <img src="/images/spinner-white.svg"/>
        </div>
      </div>
      <div id="main-container" className="main-container" style={{height: "100vh", padding: "0", background: "var(--app-background)"}}>
        {
          props.menu &&
            props.menu({tenant: props.tenant})
        }
        {
          fatal ? (
            <FatalError/>
          ) : (
            props.children
          )
        }
      </div>
    </>
  )
}

export function TenantFormTitle(props) {
  const tenant = props.tenant
  if (tenant) {
    if (tenant.accessingAs("*/MEMBER/*")) {
      return (
        <h1 className="d-flex flex-row">{props.children}</h1>
      )
    }
    else {
      return (
        <div className="d-flex flex-column">
          <p>{tenant.tenantName}</p>
          <h1 className="d-flex flex-row">{props.children}</h1>
        </div>
      )
    }
  }
  else {
    return (
      <h1 className="d-flex flex-row">{props.children}</h1>    )
  }
}

function matchPath(matchType, href, pathname) {
  // // log.debug(`matchPath: matchType=${matchType}, href=${href}, pathname=${pathname}`)
  switch (matchType) {
    case "EXACT":
      return (pathname === href)
    case "START":
    case "STARTSWITH":
      return (pathname.startsWith(href))
    case "END":
    case "ENDSWITH":
      return (pathname.endsWith(href))
    case "CONTAINS":
      return (pathname.indexOf(href) !== -1)
    default:
      return (pathname === href)
  }
}

export const Anchor = forwardRef((props, ref) => {
  const history = useHistory()
  const location = useLocation()
  let pathname = location.pathname
  let p = {}
  let active = false
  let match = props.match
  if (props.active !== undefined) {
    active = props.active
  }
  else {
    const parseResult = parsePathname(pathname)
    // // log.debug("Anchor: parseResult=", parseResult)
    if (parseResult.tenantId) {
      if (shortIdEqual(props?.user?.tenantId, parseResult.tenantId)) {
        active = matchPath(match, props.href, parseResult.path)
      }
      else {
        switch (props.tenant?.tenantTypeId) {
          case "CLIENT":
            active = (props.href === "/clients")
            break
          case "RESELLER":
            active = (props.href === "/resellers")
            break
          default:
        }
      }
    }
    else {
      // // log.debug("Anchor: ", match, props.href, parseResult)
      active = matchPath(match, props.href, parseResult.path)
    }
  }
  if (active) {
    p.className = (props.activeClassName ? props.activeClassName : "active")
    p["aria-current"] = "page"
  }
  // p.href = props.href

  // function handleClick(e) {
  //   e.preventDefault()
  //   history.push(props.href)
  // }

  return (
    <a {...p} ref={ref} style={{cursor: "pointer"}} href={props.href} title={props.title}>
      {props.children}
    </a>
  )
})

export function TextLink(props) {
  const history = useHistory()
  // const handleClick = (e) => {
  //   e.preventDefault()
  //   history.push(props.href)
  // }
  if (props.href) {
    if (props.children) {
      return (
        <a href={props.href} href={props.href}>
          {props.children}
        </a>
      )
    }
    else if (props.text) {
      return (
        <a href={props.href} href={props.href}>
          {props.text}
        </a>
      )
    }
    else {
      return <></>
    }
  }
  else {
    return <></>
  }
}

export function ExternalLink(props) {

  const [iconVisible, setIconVisible] = useState()

  function handleMouseLeave(e) {
    setIconVisible(false)
  }

  function handleMouseEnter(e) {
    setIconVisible(true)
  }

  return (
    <span>
    {/*<span className="d-flex align-items-center gap-1">*/}
      <a className="text-link" href={props.href} title={props.href} target="_blank" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <span>{props.children}</span>
      </a>
      <span key="icon-span" className="ml-1">
        <Icon name="external-link"/>
      </span>
    </span>
  )
}

export function ExternalLinkButton(props) {
  const {intl} = useIntlEx()
  let disabled = false
  switch (props.validate?.toLowerCase()) {
    case "relaxed":
      disabled = !validateUrl(props.href, {relaxed: true})
      break
    case "strict":
      disabled = !validateUrl(props.href, {relaxed: false})
      break
    default:
      disabled = false
  }
  return (
    <button key={props.key} className="btn btn-secondary" style={{borderLeft: "0 !important", width: "34px", padding: "0"}} type="button" title={props.title || props.href} disabled={disabled} onClick={(e) => window.open(props.href)}>
      <Icon name="external-link"/>
    </button>
  )
}

export function RegionLink(props) {
  if (props.region) {
    if ("SYSTEM" === props?.session?.user?.userTypeId) {
      return (
        <a className="text-link" href={`/sys/regions/${props.region.regionId.toShortId()}`} target="_blank">{props.region.regionName}</a>
      )
    }
    else {
      return (
        <span>{props.region.regionName}</span>
      )
    }
  }
  else {
    return <></>
  }
}

export function Section(props) {
  const {intl} = useIntlEx()
  return (
    <div>
      {
        props.title &&
        <>
          <div className="section-divider">
            {props.title}
          </div>
        </>
      }
      <div className="section" style={props.style}>
        {
          props.children
        }
      </div>
    </div>
  )
}

export function Label(props) {
  const {intl} = useIntlEx()
  return (
    props?.hasOwnProperty("msg") || props?.hasOwnProperty("text") ? (
      <>
        <span style={{color:`var(--label-color)`}}>
          {props.msg ? intl.msg(props.msg, props.params) : props.text ? props.text : ""}
        </span>
        <span style={{color:`var(--caption-color)`}}>
          :
        </span>
      </>
    ) : (
      props.children
    )
  )
}

export function Text(props) {
  const {intl} = useIntlEx()
  const type = props.type || "text"
  return (
    props?.hasOwnProperty("msg") || props?.hasOwnProperty("text") ? (
      <>
        <span style={{color:`var(${type}-color)`}}>
          {props.msg ? intl.msg(props.msg) : props.text ? props.text : ""}
        </span>
      </>
    ) : (
      props.children
    )
  )
}

export function SectionHeader(props) {
  const {intl} = useIntlEx()
  return (
    <div className={`${styles.section_header} ${props.className ? props.className : ""}`}>
      <h1>{props.title}</h1>
      {
        props.text &&
          <p>{props.text}</p>
      }
    </div>
  )
}

export function SelectList(props) {
  const [value, setValue] = useState()

  useEffect(() => {
    setValue(props.value)
  }, []);

  function handleClick(v) {
    setValue(v)
    if (props.onChange) {
      props.onChange(v)
    }
  }

  return (
    <ul className={styles["select-list"]}>
      {
        props.options.map(i => {
          return (
            <li>
              <div className={styles["select-list-item"]} data-item={i} data-selected={i.value === value?.value ? "true" : "false"} onClick={() => handleClick(i)}>
                {i.label}
              </div>
            </li>
          )
        })
      }
    </ul>
  )
}

export function UrlInput({ value: propValue = '', onChange, ...props }) {
  const [value, setValue] = useState(propValue)

  useEffect(() => {
    setValue(propValue ?? '')
  }, [propValue])

  function normalizeUrl(url) {
    if (!url?.length) return url
    if (url.startsWith('http://')) return `https://${url.substring(7)}`
    if (!url.startsWith('https://')) return `https://${url}`
    return url
  }

  function notifyChange(url) {
    if (onChange) {
      onChange({target: {value: url}})
    }
  }

  function handleChange(e) {
    const url = e.target.value.trim()
    setValue(url)
    notifyChange(url)
  }

  function handleBlur() {
    const url = normalizeUrl(value)
    if (url !== value) {
      setValue(url)
      notifyChange(url)
    }
  }

  function handleKeyDown(e) {
    if (e?.key === 'Enter') handleBlur()
  }

  return (
    <div className="input-group" style={{ gap: '0.5rem' }}>
      <input id="inp_urlInput" type="text" className="form-control" value={value} onChange={handleChange} onBlur={handleBlur} onKeyDown={handleKeyDown} {...props}/>
      <div className="input-group-append">
        <ExternalLinkButton href={value} validate="relaxed" />
      </div>
    </div>
  )
}

export function RangeSlider(props) {

  const [value, setValue] = useState(props.value)

  function handleChange(e) {
    let v = e.target.value
    setValue(v)
    if (props.onChange) {
      props.onChange(v)
    }
  }

  return (
    <div>
      <input className={styles["range-slider"]} id={props.id} type="range" min={props.min} max={props.max} step={props.value} value={value} onChange={handleChange}  list="markers"/>
      <datalist id="markers">
        <option value="0"></option>
        <option value="10"></option>
        <option value="20"></option>
        <option value="30"></option>
        <option value="40"></option>
      </datalist>
    </div>
  )
}

const icons = {
  "save": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-save"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} color="currentColor"><path d="M17 3.338A9.95 9.95 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10q-.002-1.03-.2-2"></path><path d="M8 12.5s1.5 0 3.5 3.5c0 0 5.559-9.167 10.5-11"></path></g></svg>,
  "create": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-save"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} color="currentColor"><path d="M17 3.338A9.95 9.95 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10q-.002-1.03-.2-2"></path><path d="M8 12.5s1.5 0 3.5 3.5c0 0 5.559-9.167 10.5-11"></path></g></svg>,
  "apply": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-save"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} color="currentColor"><path d="M17 3.338A9.95 9.95 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10q-.002-1.03-.2-2"></path><path d="M8 12.5s1.5 0 3.5 3.5c0 0 5.559-9.167 10.5-11"></path></g></svg>,
  "ok": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-save"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} color="currentColor"><path d="M17 3.338A9.95 9.95 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10q-.002-1.03-.2-2"></path><path d="M8 12.5s1.5 0 3.5 3.5c0 0 5.559-9.167 10.5-11"></path></g></svg>,
  "submit": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-save"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} color="currentColor"><path d="M17 3.338A9.95 9.95 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10q-.002-1.03-.2-2"></path><path d="M8 12.5s1.5 0 3.5 3.5c0 0 5.559-9.167 10.5-11"></path></g></svg>,
  "cancel": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-cancel"} width="1.12em" height="1.12em" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" clipRule="evenodd"></path><path fill="currentColor" d="M11.854 4.854a.5.5 0 0 0-.707-.707L8 7.293L4.854 4.147a.5.5 0 1 0-.707.707L7.293 8l-3.146 3.146a.5.5 0 0 0 .707.708L8 8.707l3.147 3.147a.5.5 0 0 0 .707-.708L8.708 8z"></path></svg>,
  "undo": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-undo"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M5.636 18.364A9 9 0 1 0 12 3C7.942 3 5.482 5.705 3 8.5"/><path d="M3 4.5v4h4"/></g></svg>,
  "add_new": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-add_new"} width="1.12em" height="1.12em" viewBox="0 0 1024 1024" {...props}><path fill="currentColor" d="M512 0C229.232 0 0 229.232 0 512c0 282.784 229.232 512 512 512c282.784 0 512-229.216 512-512C1024 229.232 794.784 0 512 0m0 961.008c-247.024 0-448-201.984-448-449.01c0-247.024 200.976-448 448-448s448 200.977 448 448s-200.976 449.01-448 449.01M736 480H544V288c0-17.664-14.336-32-32-32s-32 14.336-32 32v192H288c-17.664 0-32 14.336-32 32s14.336 32 32 32h192v192c0 17.664 14.336 32 32 32s32-14.336 32-32V544h192c17.664 0 32-14.336 32-32s-14.336-32-32-32"></path></svg>,
  // "add_new": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 15 15"><path fill="none" stroke="currentColor" d="M7.5 1v13M1 7.5h13"/></svg>,
  // "add_new": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 14 14"><path fill="currentColor" fill-rule="evenodd" d="M8 1a1 1 0 0 0-2 0v5H1a1 1 0 0 0 0 2h5v5a1 1 0 1 0 2 0V8h5a1 1 0 1 0 0-2H8z" clip-rule="evenodd"/></svg>,
  // "user_add": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" zoomAndPan="magnify" viewBox="0 0 36 36.000001" height="1.12em" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><clipPath id="1c95b737d2"><path d="M 18 17.605469 L 35.511719 17.605469 L 35.511719 35.027344 L 18 35.027344 Z M 18 17.605469 " clip-rule="nonzero"/></clipPath><clipPath id="1eaa57a4d7"><path d="M 26.757812 17.605469 C 21.921875 17.605469 18 21.523438 18 26.363281 C 18 31.199219 21.921875 35.117188 26.757812 35.117188 C 31.59375 35.117188 35.511719 31.199219 35.511719 26.363281 C 35.511719 21.523438 31.59375 17.605469 26.757812 17.605469 Z M 26.757812 17.605469 " clip-rule="nonzero"/></clipPath></defs><path fill="#ffffff" d="M 18 2.601562 C 18.40625 2.601562 18.8125 2.640625 19.210938 2.71875 C 19.613281 2.796875 20 2.917969 20.378906 3.074219 C 20.753906 3.230469 21.113281 3.421875 21.453125 3.648438 C 21.792969 3.875 22.105469 4.132812 22.394531 4.417969 C 22.683594 4.707031 22.941406 5.023438 23.167969 5.363281 C 23.394531 5.699219 23.585938 6.058594 23.742188 6.4375 C 23.898438 6.8125 24.015625 7.203125 24.09375 7.601562 C 24.175781 8 24.214844 8.40625 24.214844 8.8125 C 24.214844 9.222656 24.175781 9.625 24.09375 10.027344 C 24.015625 10.425781 23.898438 10.816406 23.742188 11.191406 C 23.585938 11.570312 23.394531 11.925781 23.167969 12.265625 C 22.941406 12.605469 22.683594 12.917969 22.394531 13.207031 C 22.105469 13.496094 21.792969 13.753906 21.453125 13.980469 C 21.113281 14.207031 20.753906 14.398438 20.378906 14.554688 C 20 14.710938 19.613281 14.828125 19.210938 14.910156 C 18.8125 14.988281 18.40625 15.027344 18 15.027344 C 17.59375 15.027344 17.1875 14.988281 16.789062 14.910156 C 16.386719 14.828125 16 14.710938 15.621094 14.554688 C 15.246094 14.398438 14.886719 14.207031 14.546875 13.980469 C 14.207031 13.753906 13.894531 13.496094 13.605469 13.207031 C 13.316406 12.917969 13.058594 12.605469 12.832031 12.265625 C 12.605469 11.925781 12.414062 11.570312 12.257812 11.191406 C 12.101562 10.816406 11.984375 10.425781 11.90625 10.027344 C 11.824219 9.625 11.785156 9.222656 11.785156 8.8125 C 11.785156 8.40625 11.824219 8 11.90625 7.601562 C 11.984375 7.203125 12.101562 6.8125 12.257812 6.4375 C 12.414062 6.058594 12.605469 5.699219 12.832031 5.363281 C 13.058594 5.023438 13.316406 4.707031 13.605469 4.417969 C 13.894531 4.132812 14.207031 3.875 14.546875 3.648438 C 14.886719 3.421875 15.246094 3.230469 15.621094 3.074219 C 16 2.917969 16.386719 2.796875 16.789062 2.71875 C 17.1875 2.640625 17.59375 2.601562 18 2.601562 M 18 0.113281 C 17.429688 0.113281 16.863281 0.167969 16.304688 0.28125 C 15.742188 0.394531 15.199219 0.558594 14.671875 0.777344 C 14.144531 0.996094 13.640625 1.261719 13.167969 1.582031 C 12.691406 1.898438 12.253906 2.257812 11.847656 2.664062 C 11.445312 3.066406 11.082031 3.503906 10.765625 3.980469 C 10.449219 4.457031 10.179688 4.957031 9.960938 5.484375 C 9.742188 6.011719 9.578125 6.554688 9.46875 7.117188 C 9.355469 7.675781 9.300781 8.242188 9.300781 8.8125 C 9.300781 9.386719 9.355469 9.949219 9.46875 10.511719 C 9.578125 11.070312 9.742188 11.617188 9.960938 12.144531 C 10.179688 12.671875 10.449219 13.171875 10.765625 13.648438 C 11.082031 14.121094 11.445312 14.5625 11.847656 14.964844 C 12.253906 15.371094 12.691406 15.730469 13.167969 16.046875 C 13.640625 16.363281 14.144531 16.632812 14.671875 16.851562 C 15.199219 17.070312 15.742188 17.234375 16.304688 17.347656 C 16.863281 17.457031 17.429688 17.511719 18 17.511719 C 18.570312 17.511719 19.136719 17.457031 19.695312 17.347656 C 20.257812 17.234375 20.800781 17.070312 21.328125 16.851562 C 21.855469 16.632812 22.359375 16.363281 22.832031 16.046875 C 23.308594 15.730469 23.746094 15.371094 24.152344 14.964844 C 24.554688 14.5625 24.917969 14.121094 25.234375 13.648438 C 25.550781 13.171875 25.820312 12.671875 26.039062 12.144531 C 26.257812 11.617188 26.421875 11.070312 26.53125 10.511719 C 26.644531 9.949219 26.699219 9.386719 26.699219 8.8125 C 26.699219 8.242188 26.644531 7.675781 26.53125 7.117188 C 26.421875 6.554688 26.257812 6.011719 26.039062 5.484375 C 25.820312 4.957031 25.550781 4.457031 25.234375 3.980469 C 24.917969 3.503906 24.554688 3.066406 24.152344 2.664062 C 23.746094 2.257812 23.308594 1.898438 22.832031 1.582031 C 22.359375 1.261719 21.855469 0.996094 21.328125 0.777344 C 20.800781 0.558594 20.257812 0.394531 19.695312 0.28125 C 19.136719 0.167969 18.570312 0.113281 18 0.113281 M 30.429688 34.914062 L 27.941406 34.914062 L 27.941406 28.699219 C 27.941406 28.289062 27.902344 27.886719 27.824219 27.488281 C 27.742188 27.085938 27.625 26.699219 27.46875 26.320312 C 27.3125 25.945312 27.121094 25.585938 26.894531 25.246094 C 26.667969 24.90625 26.410156 24.59375 26.121094 24.304688 C 25.832031 24.015625 25.519531 23.757812 25.179688 23.53125 C 24.839844 23.304688 24.484375 23.113281 24.105469 22.957031 C 23.730469 22.800781 23.339844 22.683594 22.941406 22.605469 C 22.539062 22.523438 22.136719 22.484375 21.726562 22.484375 L 14.273438 22.484375 C 13.863281 22.484375 13.460938 22.523438 13.058594 22.605469 C 12.660156 22.683594 12.269531 22.800781 11.894531 22.957031 C 11.515625 23.113281 11.160156 23.304688 10.820312 23.53125 C 10.480469 23.757812 10.167969 24.015625 9.878906 24.304688 C 9.589844 24.59375 9.332031 24.90625 9.105469 25.246094 C 8.878906 25.585938 8.6875 25.945312 8.53125 26.320312 C 8.375 26.699219 8.257812 27.085938 8.175781 27.488281 C 8.097656 27.886719 8.058594 28.289062 8.058594 28.699219 L 8.058594 34.914062 L 5.570312 34.914062 L 5.570312 28.699219 C 5.570312 28.128906 5.628906 27.5625 5.738281 27 C 5.851562 26.441406 6.015625 25.898438 6.234375 25.371094 C 6.453125 24.84375 6.71875 24.339844 7.039062 23.867188 C 7.355469 23.390625 7.714844 22.953125 8.121094 22.546875 C 8.523438 22.144531 8.964844 21.78125 9.4375 21.464844 C 9.914062 21.148438 10.414062 20.878906 10.941406 20.660156 C 11.46875 20.441406 12.015625 20.277344 12.574219 20.167969 C 13.132812 20.054688 13.699219 20 14.273438 20 L 21.726562 20 C 22.300781 20 22.867188 20.054688 23.425781 20.167969 C 23.984375 20.277344 24.53125 20.441406 25.058594 20.660156 C 25.585938 20.878906 26.085938 21.148438 26.5625 21.464844 C 27.035156 21.78125 27.476562 22.144531 27.878906 22.546875 C 28.285156 22.953125 28.644531 23.390625 28.960938 23.867188 C 29.28125 24.339844 29.546875 24.84375 29.765625 25.371094 C 29.984375 25.898438 30.148438 26.441406 30.261719 27 C 30.371094 27.5625 30.429688 28.128906 30.429688 28.699219 Z M 30.429688 34.914062 " fill-opacity="1" fill-rule="nonzero"/><g clip-path="url(#1c95b737d2)"><g clip-path="url(#1eaa57a4d7)"><path fill="#000000" d="M 18 17.605469 L 35.511719 17.605469 L 35.511719 35.117188 L 18 35.117188 Z M 18 17.605469 " fill-opacity="1" fill-rule="nonzero"/></g></g><path fill="#ffffff" d="M 26.753906 18.484375 C 22.40625 18.484375 18.882812 22.011719 18.882812 26.359375 C 18.882812 30.707031 22.40625 34.230469 26.753906 34.230469 C 31.101562 34.230469 34.625 30.707031 34.625 26.359375 C 34.625 22.011719 31.101562 18.484375 26.753906 18.484375 M 30.6875 27.144531 L 27.539062 27.144531 L 27.539062 30.292969 L 25.964844 30.292969 L 25.964844 27.144531 L 22.816406 27.144531 L 22.816406 25.570312 L 25.964844 25.570312 L 25.964844 22.421875 L 27.539062 22.421875 L 27.539062 25.570312 L 30.6875 25.570312 Z M 30.6875 27.144531 " fill-opacity="1" fill-rule="nonzero"/></svg>,
  // "edit": (props) => <svg xmlns="http://www.w3.org/2000/svg" key={props.key || "icon-edit"} width="1.12em" height="1.12em" viewBox="0 0 1024 1024" {...props}><path fill="currentColor" d="M832 512a32 32 0 1 1 64 0v352a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h352a32 32 0 0 1 0 64H192v640h640z"></path><path fill="currentColor" d="m469.952 554.24l52.8-7.552L847.104 222.4a32 32 0 1 0-45.248-45.248L477.44 501.44l-7.552 52.8zm422.4-422.4a96 96 0 0 1 0 135.808l-331.84 331.84a32 32 0 0 1-18.112 9.088L436.8 623.68a32 32 0 0 1-36.224-36.224l15.104-105.6a32 32 0 0 1 9.024-18.112l331.904-331.84a96 96 0 0 1 135.744 0z"></path></svg>,
  // "edit": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 20 20"><path fill="currentColor" d="M17.181 2.927a2.975 2.975 0 0 0-4.259-.054l-9.375 9.375a2.44 2.44 0 0 0-.656 1.194l-.877 3.95a.5.5 0 0 0 .596.597l3.927-.873a2.5 2.5 0 0 0 1.234-.678l9.358-9.358a2.975 2.975 0 0 0 .052-4.153m-3.552.653a1.975 1.975 0 1 1 2.793 2.793l-.671.671l-2.793-2.792zm-1.378 1.38l2.793 2.792l-7.98 7.98a1.5 1.5 0 0 1-.744.409l-3.16.702l.708-3.183c.059-.267.193-.511.386-.704z"/></svg>,
  // "edit": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.363 5.652l1.48-1.48a2 2 0 0 1 2.829 0l1.414 1.414a2 2 0 0 1 0 2.828l-1.48 1.48m-4.243-4.242l-9.616 9.615a2 2 0 0 0-.578 1.238l-.242 2.74a1 1 0 0 0 1.084 1.085l2.74-.242a2 2 0 0 0 1.24-.578l9.615-9.616m-4.243-4.242l4.243 4.242"/></svg>,
  "edit": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-edit"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M19.09 14.441v4.44a2.37 2.37 0 0 1-2.369 2.369H5.12a2.37 2.37 0 0 1-2.369-2.383V7.279a2.356 2.356 0 0 1 2.37-2.37H9.56"/><path d="M6.835 15.803v-2.165c.002-.357.144-.7.395-.953l9.532-9.532a1.36 1.36 0 0 1 1.934 0l2.151 2.151a1.36 1.36 0 0 1 0 1.934l-9.532 9.532a1.36 1.36 0 0 1-.953.395H8.197a1.36 1.36 0 0 1-1.362-1.362M19.09 8.995l-4.085-4.086"/></g></svg>,
  "delete": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-delete"} width="1.12em" height="1.12em" viewBox="0 0 28 28" {...props}><path fill="currentColor" d="M11.5 6h5a2.5 2.5 0 0 0-5 0M10 6a4 4 0 0 1 8 0h6.25a.75.75 0 0 1 0 1.5h-1.31l-1.217 14.603A4.25 4.25 0 0 1 17.488 26h-6.976a4.25 4.25 0 0 1-4.235-3.897L5.06 7.5H3.75a.75.75 0 0 1 0-1.5zM7.772 21.978a2.75 2.75 0 0 0 2.74 2.522h6.976a2.75 2.75 0 0 0 2.74-2.522L21.436 7.5H6.565zM11.75 11a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 .75-.75m5.25.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0z"></path></svg>,
  "publish": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-publish"} width="1.12em" height="1.12em" viewBox="0 -1 16 21" {...props}><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m1.5 9l16-6.535L14.7 17zm16-6.5l-11 10m0 0v5l3-3"></path></svg>,
  "republish": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-republish"} width="1.12em" height="1.12em" viewBox="0 -1 16 21" {...props}><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m1.5 9l16-6.535L14.7 17zm16-6.5l-11 10m0 0v5l3-3"></path></svg>,
  "release": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 2048 2048"><path fill="currentColor" d="M2048 0v64q0 167-25 310t-80 273t-137 248t-201 238q-38 38-77 75t-81 72h-210q75-54 143-112t134-124q99-101 173-203t124-213t76-234t32-265q-142 5-265 31t-233 77t-213 123t-203 173q-100 97-182 204T668 962l356 355v248q-138 80-279 156l-418-418q76-141 156-279H256V722l572-191v1q127-136 252-236t264-166t295-98t345-32zM973 1447l-372-372q-29 51-57 102t-58 102v1l282 282h1q51-29 102-57t102-58M558 896q29-46 58-91t62-89l-294 98v82zm978-128q0 53-20 99t-55 82t-81 55t-100 20q-53 0-99-20t-82-55t-55-81t-20-100q0-53 20-99t55-82t81-55t100-20q53 0 99 20t82 55t55 81t20 100m-384 0q0 27 10 50t27 40t41 28t50 10q27 0 50-10t40-27t28-41t10-50q0-27-10-50t-27-40t-41-28t-50-10q-27 0-50 10t-40 27t-28 41t-10 50m-896 768q53 0 99 20t82 55t55 81t20 100q0 53-20 99t-55 82t-81 55t-100 20H0v-256q0-53 20-99t55-82t81-55t100-20m0 384q27 0 50-10t40-27t28-41t10-50q0-27-10-50t-27-40t-41-28t-50-10q-27 0-50 10t-40 27t-28 41t-10 50v128zm1152-128v-128h640v128zm0-256v-128h640v128zm-256 512v-128h128v128zm0-512v-128h128v128zm256 512v-128h640v128zm-256-256v-128h128v128z"/></svg>,
  "clone": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-clone"} width="1.12em" height="1.12em" viewBox="0 0 512 512" {...props}><path fill="currentColor" d="M472 16H160a24.027 24.027 0 0 0-24 24v312a24.027 24.027 0 0 0 24 24h312a24.027 24.027 0 0 0 24-24V40a24.027 24.027 0 0 0-24-24m-8 328H168V48h296Z"></path><path fill="currentColor" d="M344 464H48V168h56v-32H40a24.027 24.027 0 0 0-24 24v312a24.027 24.027 0 0 0 24 24h312a24.027 24.027 0 0 0 24-24v-64h-32Z"></path></svg>,
  "cloud_download": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 17a5 5 0 1 0 0-10A1 1 0 1 0 5 9a1 1 0 0 0 0 8h1m3 3l3 3l3-3m-3 3V11"/></svg>,
  "cloud_upload": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 17a5 5 0 1 0 0-10A1 1 0 1 0 5 9a1 1 0 0 0 0 8h1m3-3l3-3l3 3m-3 9V11"/></svg>,
  "upload": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 9l5-5l5 5m-5-5v12"/></svg>,
  "download": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5l5-5m-5-7v12"/></svg>,
  "approve": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m23 12l-2.44-2.78l.34-3.68l-3.61-.82l-1.89-3.18L12 3L8.6 1.54L6.71 4.72l-3.61.81l.34 3.68L1 12l2.44 2.78l-.34 3.69l3.61.82l1.89 3.18L12 21l3.4 1.46l1.89-3.18l3.61-.82l-.34-3.68zm-13 5l-4-4l1.41-1.41L10 14.17l6.59-6.59L18 9z"/></svg>,
  "reject": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path fill="currentColor" d="m23 12l-2.44-2.78l.34-3.68l-3.61-.82l-1.89-3.18L12 3L8.6 1.54L6.71 4.72l-3.61.81l.34 3.68L1 12l2.44 2.78l-.34 3.69l3.61.82l1.89 3.18L12 21l3.4 1.46l1.89-3.18l3.61-.82l-.34-3.68zm-7.5-3.5L12 12l3.5 3.5l-1.5 1.5l-3.5-3.5l-3.5 3.5l-1.5-1.5l3.5-3.5l-3.5-3.5l1.5-1.5l3.5 3.5l3.5-3.5z"/></svg>,
  "decline": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path fill="currentColor" d="m23 12l-2.44-2.78l.34-3.68l-3.61-.82l-1.89-3.18L12 3L8.6 1.54L6.71 4.72l-3.61.81l.34 3.68L1 12l2.44 2.78l-.34 3.69l3.61.82l1.89 3.18L12 21l3.4 1.46l1.89-3.18l3.61-.82l-.34-3.68zm-7.5-3.5L12 12l3.5 3.5l-1.5 1.5l-3.5-3.5l-3.5 3.5l-1.5-1.5l3.5-3.5l-3.5-3.5l1.5-1.5l3.5 3.5l3.5-3.5z"/></svg>,
  "deny": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path fill="currentColor" d="m23 12l-2.44-2.78l.34-3.68l-3.61-.82l-1.89-3.18L12 3L8.6 1.54L6.71 4.72l-3.61.81l.34 3.68L1 12l2.44 2.78l-.34 3.69l3.61.82l1.89 3.18L12 21l3.4 1.46l1.89-3.18l3.61-.82l-.34-3.68zm-7.5-3.5L12 12l3.5 3.5l-1.5 1.5l-3.5-3.5l-3.5 3.5l-1.5-1.5l3.5-3.5l-3.5-3.5l1.5-1.5l3.5 3.5l3.5-3.5z"/></svg>,

  "invite": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none" fill-rule="evenodd"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path fill="currentColor" d="M17 3a3 3 0 0 1 2.995 2.824L20 6v4.35l.594-.264c.614-.273 1.322.15 1.4.798L22 11v8a2 2 0 0 1-1.85 1.995L20 21H4a2 2 0 0 1-1.995-1.85L2 19v-8c0-.672.675-1.147 1.297-.955l.11.041l.593.264V6a3 3 0 0 1 2.824-2.995L7 3zm3 9.539l-7.188 3.194a2 2 0 0 1-1.624 0L4 12.54V19h16zM17 5H7a1 1 0 0 0-1 1v5.239l6 2.667l6-2.667V6a1 1 0 0 0-1-1m-5 3a1 1 0 0 1 .117 1.993L12 10h-2a1 1 0 0 1-.117-1.993L10 8z"/></g></svg>,

  "override": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 36 36" {...props}><path fill="currentColor" d="M19.5 28.1h-2.9c-.5 0-.9-.3-1-.8l-.5-1.8l-.4-.2l-1.6.9c-.4.2-.9.2-1.2-.2l-2.1-2.1c-.3-.3-.4-.8-.2-1.2l.9-1.6l-.2-.4l-1.8-.5c-.4-.1-.8-.5-.8-1v-2.9c0-.5.3-.9.8-1l1.8-.5l.2-.4l-.9-1.6c-.2-.4-.2-.9.2-1.2l2.1-2.1c.3-.3.8-.4 1.2-.2l1.6.9l.4-.2l.5-1.8c.1-.4.5-.8 1-.8h2.9c.5 0 .9.3 1 .8L21 10l.4.2l1.6-.9c.4-.2.9-.2 1.2.2l2.1 2.1c.3.3.4.8.2 1.2l-.9 1.6l.2.4l1.8.5c.4.1.8.5.8 1v2.9c0 .5-.3.9-.8 1l-1.8.5l-.2.4l.9 1.6c.2.4.2.9-.2 1.2L24.2 26c-.3.3-.8.4-1.2.2l-1.6-.9l-.4.2l-.5 1.8c-.2.5-.6.8-1 .8m-2.2-2h1.4l.5-2.1l.5-.2c.4-.1.7-.3 1.1-.4l.5-.3l1.9 1.1l1-1l-1.1-1.9l.3-.5c.2-.3.3-.7.4-1.1l.2-.5l2.1-.5v-1.4l-2.1-.5l-.2-.5c-.1-.4-.3-.7-.4-1.1l-.3-.5l1.1-1.9l-1-1l-1.9 1.1l-.5-.3c-.3-.2-.7-.3-1.1-.4l-.5-.2l-.5-2.1h-1.4l-.5 2.1l-.5.2c-.4.1-.7.3-1.1.4l-.5.3l-1.9-1.1l-1 1l1.1 1.9l-.3.5c-.2.3-.3.7-.4 1.1l-.2.5l-2.1.5v1.4l2.1.5l.2.5c.1.4.3.7.4 1.1l.3.5l-1.1 1.9l1 1l1.9-1.1l.5.3c.3.2.7.3 1.1.4l.5.2zm9.8-6.6"/><path fill="currentColor" d="M18 22.3c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3s4.3 1.9 4.3 4.3s-1.9 4.3-4.3 4.3m0-6.6c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3s2.3-1 2.3-2.3s-1-2.3-2.3-2.3"/><path fill="currentColor" d="M18 2c-.6 0-1 .4-1 1s.4 1 1 1c7.7 0 14 6.3 14 14s-6.3 14-14 14S4 25.7 4 18c0-2.8.8-5.5 2.4-7.8v1.2c0 .6.4 1 1 1s1-.4 1-1v-5h-5c-.6 0-1 .4-1 1s.4 1 1 1h1.8C3.1 11.1 2 14.5 2 18c0 8.8 7.2 16 16 16s16-7.2 16-16S26.8 2 18 2"/><path fill="none" d="M0 0h36v36H0z"/></svg>,

  // "import": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M11.5 15.577v-8.65l-2.33 2.33l-.708-.718L12 5l3.539 3.539l-.708.719L12.5 6.927v8.65zM6.616 19q-.691 0-1.153-.462T5 17.384v-2.423h1v2.423q0 .231.192.424t.423.192h10.77q.23 0 .423-.192t.192-.424v-2.423h1v2.423q0 .691-.462 1.153T17.384 19z"/></svg>,
  // "export": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-export"} width="1.12em" height="1.12em" viewBox="0 0 32 32" {...props}><path fill="currentColor" d="M13 21h13.17l-2.58 2.59L25 25l5-5l-5-5l-1.41 1.41L26.17 19H13z"/><path fill="currentColor" d="M22 14v-4a1 1 0 0 0-.29-.71l-7-7A1 1 0 0 0 14 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2h-2v2H4V4h8v6a2 2 0 0 0 2 2h6v2Zm-8-4V4.41L19.59 10Z"/></svg>,
  "import": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 9l5-5l5 5m-5-5v12"/></svg>,
  "export": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5l5-5m-5-7v12"/></svg>,
  "sync": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M7.308 20.308L3 16l4.308-4.308l.713.708l-3.1 3.1H20v1H4.921l3.1 3.1zm9.384-8l-.713-.708l3.1-3.1H4v-1h15.079l-3.1-3.1l.713-.708L21 8z"/></svg>,
  "refresh": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path fill="currentColor" d="M20.5 16h-4a.5.5 0 0 0 0 1h2.976a9 9 0 0 1-7.459 4a9.01 9.01 0 0 1-8.904-10.419a.5.5 0 0 0-.986-.162A10 10 0 0 0 2 12c.006 5.52 4.48 9.994 10 10a10.01 10.01 0 0 0 8-3.999v2.5a.5.5 0 1 0 1 0v-4.002a.5.5 0 0 0-.5-.499M16.737 3.196C12.32.818 6.921 2.107 4 6.003V3.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1H4.524a9 9 0 0 1 7.459-4a9.01 9.01 0 0 1 8.903 10.421a.499.499 0 1 0 .987.16A10 10 0 0 0 22 12a10.01 10.01 0 0 0-5.263-8.804M15 12a3 3 0 1 0-6 0a3 3 0 0 0 6 0m-5 0a2 2 0 1 1 4 0a2 2 0 0 1-4 0"/></svg>,
  "stop": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-stop"} width="1.12em" height="1.12em" viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M10 3a7 7 0 1 0 0 14a7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0a8 8 0 0 1-16 0m5-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"></path></svg>,
  "settle": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="currentColor"><path d="M19.5 13V9.368c0-3.473 0-5.21-1.025-6.289S15.8 2 12.5 2h-3C6.2 2 4.55 2 3.525 3.08C2.5 4.157 2.5 5.894 2.5 9.367v5.264c0 3.473 0 5.21 1.025 6.289S6.2 22 9.5 22H11m2.5-2s1 0 2 2c0 0 3.177-5 6-6"/><path d="m7 2l.082.493c.2 1.197.3 1.796.72 2.152C8.22 5 8.827 5 10.041 5h1.917c1.213 0 1.82 0 2.24-.355c.42-.356.52-.955.719-2.152L15 2M7 16h4m-4-5h8"/></g></svg>,
  "demo": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-demo"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M2 2h20v2h-1v14h-6.586l4 4L17 23.414l-5-5l-5 5L5.586 22l4-4H3V4H2zm3 2v12h14V4zm5 2.5l4.667 3.5L10 13.5z"/></svg>,
  "test": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 2048 2048"><path fill="currentColor" d="M1859 1758q14 23 21 47t7 51q0 40-15 75t-41 61t-61 41t-75 15H354q-40 0-75-15t-61-41t-41-61t-15-75q0-27 6-51t21-47l569-992q10-14 10-34V128H640V0h768v128h-128v604q0 19 10 35zM896 732q0 53-27 99l-331 577h972l-331-577q-27-46-27-99V128H896z"/></svg>,
  "external-link": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-external_link"} width="1.12em" height="1.12em" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M14 16V5l-1 1v9H1V3h9l1-1H0v14z"></path><path fill="currentColor" d="M16 0h-5l1.8 1.8L6 8.6L7.4 10l6.8-6.8L16 5z"></path></svg>,
  "details": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-details"} width="1.12em" height="1.12em" viewBox="0 0 36 36" {...props}><path fill="currentColor" d="M32 6H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m0 22H4V8h28Z" className="clr-i-outline clr-i-outline-path-1"></path><path fill="currentColor" d="M9 14h18a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2" className="clr-i-outline clr-i-outline-path-2"></path><path fill="currentColor" d="M9 18h18a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2" className="clr-i-outline clr-i-outline-path-3"></path><path fill="currentColor" d="M9 22h10a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2" className="clr-i-outline clr-i-outline-path-4"></path><path fill="none" d="M0 0h36v36H0z"></path></svg>,
  "more_menu": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-more_menu"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M12 16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2"></path></svg>,
  "reinvite": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-email_resend"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M3 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10.5a6.5 6.5 0 0 1-.5-2H3V8l8 5l8-5v3a7 7 0 0 1 .5 0a6.5 6.5 0 0 1 1.5.18V6c0-1.1-.9-2-2-2zm0 2h16l-8 5zm16 6l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4zm-3.33 3.29c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12z"></path></svg>,
  "move": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-move"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m7.366 19.789l-.708-.708l2.056-2.073q-2.631-.127-4.557-1.798Q2.23 13.54 2.23 11t1.826-4.27T8.442 5H10.5v1H8.461Q6.31 6 4.772 7.443Q3.23 8.887 3.23 11q0 2.108 1.64 3.492q1.64 1.385 3.858 1.504l-2.071-2.071l.707-.713l3.289 3.288zM13.5 19v-5.808H21V19zm0-8.192V5H21v5.808zm1-1H20V6h-5.5z"></path></svg>,
  "bank_transfer": (props) => <svg xmlns="http://www.w3.org/2000/svg" key={props.key || "icon-bank_transfer"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M15 14v-3h3V9l4 3.5l-4 3.5v-2zm-1-6.3V9H2V7.7L8 4zM7 10h2v5H7zm-4 0h2v5H3zm10 0v2.5l-2 1.8V10zm-3.9 6l-.6.5l1.7 1.5H2v-2zm7.9-1v3h-3v2l-4-3.5l4-3.5v2z"/></svg>,
  "credits_transfer": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M17.12 9.88a2.997 2.997 0 1 0-4.24 4.24a2.997 2.997 0 1 0 4.24-4.24M7 6v12h16V6zm14 8c-.53 0-1.04.21-1.41.59c-.38.37-.59.88-.59 1.41h-8c0-.53-.21-1.04-.59-1.41c-.37-.38-.88-.59-1.41-.59v-4c.53 0 1.04-.21 1.41-.59c.38-.37.59-.88.59-1.41h8c0 .53.21 1.04.59 1.41c.37.38.88.59 1.41.59zM5 8H3c-.55 0-1-.45-1-1s.45-1 1-1h2zm0 5H2c-.55 0-1-.45-1-1s.45-1 1-1h3zm0 5H1c-.552 0-1-.45-1-1s.448-1 1-1h4z"/></svg>,
  "print": (props) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="1.12em" height="1.12em"  {...props}><path stroke-linecap="round" stroke-linejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"/></svg>,
  "invoice": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 15 15" {...props}><path fill="currentColor" d="M4.5 6.995H4v1h.5zm6 1h.5v-1h-.5zM4.5 9.5H4v.5h.5zm6 0v.5h.5v-.5zm-6-4V5H4v.5zm6 0h.5V5h-.5zm3-2h.5v-.207l-.146-.147zm-3-3l.354-.354L10.707 0H10.5zm-6 7.495h6v-1h-6zM4.5 10h6V9h-6zm0-4h6V5h-6zm8 8h-10v1h10zM2 13.5v-12H1v12zm11-10v10h1v-10zM2.5 1h8V0h-8zm7.646-.146l3 3l.708-.708l-3-3zM2.5 14a.5.5 0 0 1-.5-.5H1A1.5 1.5 0 0 0 2.5 15zm10 1a1.5 1.5 0 0 0 1.5-1.5h-1a.5.5 0 0 1-.5.5zM2 1.5a.5.5 0 0 1 .5-.5V0A1.5 1.5 0 0 0 1 1.5zm2 4v4h1v-4zm3 0v4h1v-4zm3 0v4h1v-4zM4 4h3V3H4zm4 8h3v-1H8z"/></svg>,
  "click": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 36 36" {...props}><path fill="currentColor" d="M30.4 17.6c-1.8-1.9-4.2-3.2-6.7-3.7q-1.65-.45-3.3-.6c2.8-3.3 2.3-8.3-1-11.1s-8.3-2.3-11.1 1s-2.3 8.3 1 11.1c.6.5 1.2.9 1.8 1.1v2.2l-1.6-1.5c-1.4-1.4-3.7-1.4-5.2 0c-1.4 1.4-1.5 3.6-.1 5l4.6 5.4c.2 1.4.7 2.7 1.4 3.9c.5.9 1.2 1.8 1.9 2.5v1.9c0 .6.4 1 1 1h13.6c.5 0 1-.5 1-1v-2.6c1.9-2.3 2.9-5.2 2.9-8.1v-5.8c.1-.4 0-.6-.2-.7m-22-9.4c0-3.3 2.7-5.9 6-5.8c3.3 0 5.9 2.7 5.8 6c0 1.8-.8 3.4-2.2 4.5v-5a3.4 3.4 0 0 0-3.4-3.2c-1.8-.1-3.4 1.4-3.4 3.2v5.2c-1.7-1-2.7-2.9-2.8-4.9M28.7 24c.1 2.6-.8 5.1-2.5 7.1c-.2.2-.4.4-.4.7v2.1H14.2v-1.4c0-.3-.2-.6-.4-.8c-.7-.6-1.3-1.3-1.8-2.2c-.6-1-1-2.2-1.2-3.4c0-.2-.1-.4-.2-.6l-4.8-5.7c-.3-.3-.5-.7-.5-1.2c0-.4.2-.9.5-1.2c.7-.6 1.7-.6 2.4 0l2.9 2.9v3l1.9-1V7.9c.1-.7.7-1.3 1.5-1.2c.7 0 1.4.5 1.4 1.2v11.5l2 .4v-4.6c.1-.1.2-.1.3-.2c.7 0 1.4.1 2.1.2v5.1l1.6.3v-5.2l1.2.3c.5.1 1 .3 1.5.5v5l1.6.3v-4.6c.9.4 1.7 1 2.4 1.7z" className="clr-i-outline clr-i-outline-path-1"/><path fill="none" d="M0 0h36v36H0z"/></svg>,
  "view": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 36 36" {...props}><path fill="currentColor" d="M30.4 17.6c-1.8-1.9-4.2-3.2-6.7-3.7q-1.65-.45-3.3-.6c2.8-3.3 2.3-8.3-1-11.1s-8.3-2.3-11.1 1s-2.3 8.3 1 11.1c.6.5 1.2.9 1.8 1.1v2.2l-1.6-1.5c-1.4-1.4-3.7-1.4-5.2 0c-1.4 1.4-1.5 3.6-.1 5l4.6 5.4c.2 1.4.7 2.7 1.4 3.9c.5.9 1.2 1.8 1.9 2.5v1.9c0 .6.4 1 1 1h13.6c.5 0 1-.5 1-1v-2.6c1.9-2.3 2.9-5.2 2.9-8.1v-5.8c.1-.4 0-.6-.2-.7m-22-9.4c0-3.3 2.7-5.9 6-5.8c3.3 0 5.9 2.7 5.8 6c0 1.8-.8 3.4-2.2 4.5v-5a3.4 3.4 0 0 0-3.4-3.2c-1.8-.1-3.4 1.4-3.4 3.2v5.2c-1.7-1-2.7-2.9-2.8-4.9M28.7 24c.1 2.6-.8 5.1-2.5 7.1c-.2.2-.4.4-.4.7v2.1H14.2v-1.4c0-.3-.2-.6-.4-.8c-.7-.6-1.3-1.3-1.8-2.2c-.6-1-1-2.2-1.2-3.4c0-.2-.1-.4-.2-.6l-4.8-5.7c-.3-.3-.5-.7-.5-1.2c0-.4.2-.9.5-1.2c.7-.6 1.7-.6 2.4 0l2.9 2.9v3l1.9-1V7.9c.1-.7.7-1.3 1.5-1.2c.7 0 1.4.5 1.4 1.2v11.5l2 .4v-4.6c.1-.1.2-.1.3-.2c.7 0 1.4.1 2.1.2v5.1l1.6.3v-5.2l1.2.3c.5.1 1 .3 1.5.5v5l1.6.3v-4.6c.9.4 1.7 1 2.4 1.7z" className="clr-i-outline clr-i-outline-path-1"/><path fill="none" d="M0 0h36v36H0z"/></svg>,
  "direct_deposit": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="m8 16l-2-3h1v-2h2v2h1zm7-15v8H1V1zm1-1H0v10h16z"/><path fill="currentColor" d="M8 2a3 3 0 1 1 0 6h5V7h1V3h-1V2zM5 5a3 3 0 0 1 3-3H3v1H2v4h1v1h5a3 3 0 0 1-3-3"/></svg>,
  "offline_payment": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h7a1.5 1.5 0 0 0 1.5-1.5V15a.5.5 0 0 0-.5-.5c-.413 0-.677-.102-.856-.236q-.273-.204-.424-.623c-.214-.588-.22-1.367-.22-2.141a.5.5 0 0 0-.147-.354l-.286-.287l-1.213-1.213c-.467-.467-.604-.78-.63-.955c-.02-.14.022-.234.122-.33c.214-.205.367-.344.54-.386c.103-.026.338-.044.76.378l3 3a.5.5 0 0 0 .708-.707L13 9.793V6.707l2.56 2.56a1.5 1.5 0 0 1 .44 1.061V17.5a.5.5 0 0 0 1 0v-7.172a2.5 2.5 0 0 0-.732-1.767L13 5.293V3.5A1.5 1.5 0 0 0 11.5 2zM12 5.5v3.293l-1.146-1.147c-.578-.578-1.154-.777-1.705-.643a1.5 1.5 0 0 0-.313.115A3 3 0 0 0 5 10a3 3 0 0 0 5.007 2.23c.017.578.075 1.21.273 1.753c.148.407.384.796.764 1.08l.006.006A1.5 1.5 0 0 0 10 16.5v.5H6v-.5A1.5 1.5 0 0 0 4.5 15H4V5h.5A1.5 1.5 0 0 0 6 3.5V3h4v.5A1.5 1.5 0 0 0 11.5 5h.5zm0 11v.009a.5.5 0 0 1-.5.491H11v-.5a.5.5 0 0 1 .5-.5h.5zM6 10a2 2 0 0 1 1.874-1.996c-.124.23-.187.51-.139.833c.071.482.378.983.911 1.516l.907.907A2 2 0 0 1 6 10M5 3v.5a.5.5 0 0 1-.5.5H4v-.5a.5.5 0 0 1 .5-.5zM4 16h.5a.5.5 0 0 1 .5.5v.5h-.5a.5.5 0 0 1-.5-.5zm8-12h-.5a.5.5 0 0 1-.5-.5V3h.5a.5.5 0 0 1 .5.5z"/></svg>,
  "reverse": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 48 48" {...props}><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M6 5h18v32H6zm18 6h18v32H24z"/><path d="m13 17l4 3.79L13.333 25M35 23l-4 3.79L34.667 31"/></g></svg>,
  "adjust": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 48 48" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M5 8a3 3 0 0 1 3-3h32a3 3 0 0 1 3 3v32a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3zm31 4L12 36m0-20h8m7 17h8M16 12v8"/></svg>,
  "profile": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g fill="none"><path stroke="currentColor" stroke-width="1.5" d="M21 12a8.96 8.96 0 0 1-1.526 5.016A8.99 8.99 0 0 1 12 21a8.99 8.99 0 0 1-7.474-3.984A9 9 0 1 1 21 12Z"/><path fill="currentColor" d="M13.25 9c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0 0 14.75 9zM12 10.25c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 12 11.75zM10.75 9c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 9.25 9zM12 7.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0 0 12 6.25zM5.166 17.856l-.719-.214l-.117.392l.267.31zm13.668 0l.57.489l.266-.31l-.117-.393zM9 15.75h6v-1.5H9zm0-1.5a4.75 4.75 0 0 0-4.553 3.392l1.438.428A3.25 3.25 0 0 1 9 15.75zm3 6a8.23 8.23 0 0 1-6.265-2.882l-1.138.977A9.73 9.73 0 0 0 12 21.75zm3-4.5c1.47 0 2.715.978 3.115 2.32l1.438-.428A4.75 4.75 0 0 0 15 14.25zm3.265 1.618A8.23 8.23 0 0 1 12 20.25v1.5a9.73 9.73 0 0 0 7.403-3.405z"/></g></svg>,
  "signout": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M9 20.75H6a2.64 2.64 0 0 1-2.75-2.53V5.78A2.64 2.64 0 0 1 6 3.25h3a.75.75 0 0 1 0 1.5H6a1.16 1.16 0 0 0-1.25 1v12.47a1.16 1.16 0 0 0 1.25 1h3a.75.75 0 0 1 0 1.5Zm7-4a.74.74 0 0 1-.53-.22a.75.75 0 0 1 0-1.06L18.94 12l-3.47-3.47a.75.75 0 1 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.74.74 0 0 1-.53.22"/><path fill="currentColor" d="M20 12.75H9a.75.75 0 0 1 0-1.5h11a.75.75 0 0 1 0 1.5"/></svg>,
  "cross": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 21 21" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m15.5 15.5l-10-10zm0-10l-10 10"/></svg>,
  "move_up": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M11 8v6h1V8h2.5l-3-3l-3 3zM1 3h1.5v1H1zm2 0h1.5v1H3zm2 0h1v1.5H5zM1 6.5h1V8H1zm1.5.5H4v1H2.5zm2 0H6v1H4.5zM1 4.5h1V6H1zM5 5h1v1.5H5zm0 6v3H2v-3zm1-1H1v5h5z"/></svg>,
  "move_down": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12 11V5h-1v6H8.5l3 3l3-3zM5 4v3H2V4zm1-1H1v5h5zm-5 7h1.5v1H1zm2 0h1.5v1H3zm2 0h1v1.5H5zm-4 3.5h1V15H1zm1.5.5H4v1H2.5zm2 0H6v1H4.5zM1 11.5h1V13H1zm4 .5h1v1.5H5z"/></svg>,
  "envelope": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 36 36" {...props}><path fill="currentColor" d="M32 6H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-1.54 22H5.66l7-7.24l-1.44-1.39L4 26.84V9.52l12.43 12.37a2 2 0 0 0 2.82 0L32 9.21v17.5l-7.36-7.36l-1.41 1.41ZM5.31 8h25.07L17.84 20.47Z" className="clr-i-outline clr-i-outline-path-1"/><path fill="none" d="M0 0h36v36H0z"/></svg>,
  "envelope2": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M19 14.5v-9c0-.83-.67-1.5-1.5-1.5H3.49c-.83 0-1.5.67-1.5 1.5v9c0 .83.67 1.5 1.5 1.5H17.5c.83 0 1.5-.67 1.5-1.5m-1.31-9.11c.33.33.15.67-.03.84L13.6 9.95l3.9 4.06c.12.14.2.36.06.51c-.13.16-.43.15-.56.05l-4.37-3.73l-2.14 1.95l-2.13-1.95l-4.37 3.73c-.13.1-.43.11-.56-.05c-.14-.15-.06-.37.06-.51l3.9-4.06l-4.06-3.72c-.18-.17-.36-.51-.03-.84s.67-.17.95.07l6.24 5.04l6.25-5.04c.28-.24.62-.4.95-.07"/></svg>,
  "info": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M13 7.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-3 3.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.25h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75V12h-.75a.75.75 0 0 1-.75-.75"/><path fill="currentColor" d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12S5.925 1 12 1M2.5 12a9.5 9.5 0 0 0 9.5 9.5a9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5A9.5 9.5 0 0 0 2.5 12"/></svg>,
  "question": (props) => <svg xmlns="http://www.w3.org/2000/svg" className="icon" key={props.key || "icon-info"} width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M11 18h2v-2h-2zm1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-14a4 4 0 0 0-4 4h2a2 2 0 0 1 2-2a2 2 0 0 1 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4"/></svg>,
  "notice": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g className="alert-outline"><g fill="currentColor" className="Vector"><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10m-10 8a8 8 0 1 0 0-16a8 8 0 0 0 0 16" clip-rule="evenodd"/><path fill-rule="evenodd" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1" clip-rule="evenodd"/><path d="M11 16a1 1 0 1 1 2 0a1 1 0 0 1-2 0"/></g></g></svg>,
  "warning": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><g className="warning-outline"><g fill="currentColor" className="Vector"><path fill-rule="evenodd" d="M12 13.8a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1" clip-rule="evenodd"/><path d="M10.947 15.958a1.053 1.053 0 1 1 2.106 0a1.053 1.053 0 0 1-2.106 0"/><path fill-rule="evenodd" d="m15.607 4.642l5.876 10.72c1.512 2.759-.473 6.138-3.607 6.138H6.124c-3.134 0-5.12-3.38-3.607-6.139l5.876-10.72c1.566-2.855 5.648-2.855 7.214 0Zm-1.804 1c-.782-1.429-2.824-1.429-3.606 0L4.32 16.36c-.757 1.38.236 3.069 1.803 3.069h11.752c1.567 0 2.56-1.69 1.803-3.07z" clip-rule="evenodd"/></g></g></svg>,
  "error": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M12 16h.008M12 8v5M3.23 7.913L7.91 3.23c.15-.15.35-.23.57-.23h7.05c.21 0 .42.08.57.23l4.67 4.673c.15.15.23.35.23.57v7.054c0 .21-.08.42-.23.57L16.1 20.77c-.15.15-.35.23-.57.23H8.47a.8.8 0 0 1-.57-.23l-4.67-4.673a.8.8 0 0 1-.23-.57V8.473c0-.21.08-.42.23-.57z"/></svg>,
  "success": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 512 512" {...props}><path fill="currentColor" fill-rule="evenodd" d="M256 42.667C138.18 42.667 42.667 138.18 42.667 256S138.18 469.334 256 469.334S469.334 373.82 469.334 256S373.821 42.667 256 42.667m0 384c-94.105 0-170.666-76.561-170.666-170.667S161.894 85.334 256 85.334S426.667 161.894 426.667 256S350.106 426.667 256 426.667m80.336-246.886l30.167 30.167l-131.836 132.388l-79.083-79.083l30.166-30.167l48.917 48.917z"/></svg>,

  "edit-bold": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M6 4.75c0-.69.56-1.25 1.25-1.25h5a4.752 4.752 0 0 1 3.888 7.479A5 5 0 0 1 14 20.5H7.25c-.69 0-1.25-.56-1.25-1.25ZM8.5 13v5H14a2.5 2.5 0 1 0 0-5Zm0-2.5h3.751A2.25 2.25 0 0 0 12.25 6H8.5Z"/></svg>,
  "edit-italic": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M10 4.75a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-3.514l-5.828 13h3.342a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h3.514l5.828-13H10.75a.75.75 0 0 1-.75-.75"/></svg>,
  "edit-ol": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M5.75 2.5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5m0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5m0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5M2 14a1 1 0 1 1 0-2a1 1 0 0 1 0 2m1-6a1 1 0 1 1-2 0a1 1 0 0 1 2 0M2 4a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/></svg>,
  "edit-ul": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M5.75 2.5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5m0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5m0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5M2 14a1 1 0 1 1 0-2a1 1 0 0 1 0 2m1-6a1 1 0 1 1-2 0a1 1 0 0 1 2 0M2 4a1 1 0 1 1 0-2a1 1 0 0 1 0 2"/></svg>,
  "edit-highlight": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M6.066 7.767L4.93 6.64q-.147-.141-.153-.342q-.007-.2.153-.366q.165-.165.356-.168t.357.162l1.129 1.129q.14.14.153.341t-.153.367q-.16.16-.351.162t-.357-.157M11.5 5.384V3.77q0-.213.143-.357T12 3.27t.357.143t.143.357v1.616q0 .213-.143.356T12 5.885t-.357-.144t-.143-.356m5.739 1.663l1.123-1.123q.14-.14.341-.15q.2-.01.366.156q.16.16.16.354t-.16.354l-1.123 1.123q-.14.14-.341.153t-.366-.148q-.166-.165-.166-.36t.166-.359M10 19.385v-2.808l-2.521-2.521q-.218-.217-.348-.522Q7 13.229 7 12.906v-1.29q0-.672.472-1.144T8.616 10h6.769q.67 0 1.143.472q.472.472.472 1.144v1.29q0 .323-.13.628q-.132.305-.349.522L14 16.577v2.808q0 .67-.472 1.143q-.472.472-1.143.472h-.77q-.67 0-1.143-.472Q10 20.056 10 19.385m1.616.615h.769q.269 0 .442-.173t.173-.442v-3.23l3-3v-1.54q0-.269-.173-.442T15.385 11h-6.77q-.269 0-.442.173T8 11.616v1.54l3 3v3.229q0 .269.173.442t.443.173M12 15.5"/></svg>,

  "under_maintenance": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 48 48" {...props}><path fill="currentColor" fill-rule="evenodd" d="M21.058 7.52c-2.698.984-4.814 3.285-5.659 6.174C13.898 14.464 13 15.44 13 16.5c0 1.198 1.144 2.287 3.01 3.093Q16 19.795 16 20a8 8 0 1 0 15.99-.407C33.856 18.787 35 17.698 35 16.5c0-1.061-.898-2.036-2.4-2.806c-.844-2.89-2.96-5.19-5.658-6.175A2 2 0 0 0 25 6h-2a2 2 0 0 0-1.942 1.52M22 12a1 1 0 0 0 1-1V8h2v3a1 1 0 1 0 2 0V9.722c1.587.81 2.868 2.253 3.525 4.056l-.008.035a1.4 1.4 0 0 1-.157.107c-.286.17-.758.356-1.412.526c-1.293.337-3.081.554-4.948.554s-3.655-.217-4.948-.554c-.654-.17-1.126-.356-1.412-.526a1.4 1.4 0 0 1-.157-.107l-.002-.009l-.006-.026c.657-1.803 1.938-3.247 3.525-4.056V11a1 1 0 0 0 1 1m-5.656 3.458l-.033.016c-.607.311-.974.607-1.167.828a.8.8 0 0 0-.138.198c.021.048.082.152.249.314c.313.303.871.668 1.724 1.017C18.675 18.525 21.157 19 24 19s5.325-.475 7.02-1.17c.854-.348 1.412-.713 1.725-1.016c.167-.162.228-.266.249-.314a.8.8 0 0 0-.138-.198c-.193-.221-.56-.517-1.167-.828l-.033-.016a3 3 0 0 1-.272.18c-.517.308-1.195.552-1.933.744C27.961 16.77 26 17 24 17s-3.961-.23-5.451-.618c-.738-.192-1.416-.436-1.933-.745a3 3 0 0 1-.272-.18m16.66 1.07L33 16.52zm0-.058q-.002 0-.003.01l.002-.008zm-18.006.006l-.001-.006l.002.01zm0 .048v-.005v.003l-.001.006zm14.996 3.75C28.27 20.734 26.21 21 24 21s-4.27-.267-5.994-.726a6 6 0 0 0 11.988 0m4.691 6.32a1 1 0 0 0-1.274-1.25A6.502 6.502 0 0 0 32 36.977V41a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4.022a6.502 6.502 0 0 0-1.411-11.635a1 1 0 0 0-1.274 1.251l.022.082l.557 2.6a1.425 1.425 0 1 1-2.788 0l.557-2.6zm4.164 2.263l-.1-.472a4.5 4.5 0 0 1-1.205 7.125a1 1 0 0 0-.545.93l.001.06V40h-3v-3.508l.001-.052a1 1 0 0 0-.544-.93a4.5 4.5 0 0 1-1.205-7.125l-.101.472a3.425 3.425 0 1 0 6.698 0m-20.496-.249L23 32.222v3.675c.205.052.525.103 1 .103s.795-.05 1-.103V32l2-1.5V42H6v-6c0-3.661 6.52-6.273 12.353-7.392m-3.878 7.66L21 35.181V40h-8v-7.82a31 31 0 0 1 3.35-1.07zM8 40h3v-6.921l-.074.039c-1.064.564-1.842 1.139-2.332 1.68C8.114 35.33 8 35.723 8 36zm16-2q-.566-.002-1-.067V40h2v-2.067q-.434.065-1 .067m-3.05-4.839l-2.508-1.95l-.917 2.521z" clip-rule="evenodd"/></svg>,

  // "impersonate": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M7.8 17q-1.063 0-2.072-.383t-1.78-1.104q-1.007-.97-1.478-2.335Q2 11.814 2 10.375q0-1.489.7-2.432T4.744 7q.235 0 .47.043q.236.043.465.13L12 9.552l6.321-2.379q.229-.087.464-.13t.47-.043q1.345 0 2.045.943t.7 2.432q0 1.439-.47 2.803t-1.478 2.336q-.771.72-1.78 1.103T16.2 17q-1.38 0-2.483-.75l-1.102-.75h-1.23l-1.102.75Q9.18 17 7.8 17m.925-3.23q.61 0 .977-.28t.367-.74q-.019-.879-1.242-1.699t-2.552-.82q-.61 0-.967.28q-.358.28-.358.739q.02.898 1.233 1.709q1.213.81 2.542.81m6.55 0q1.329 0 2.552-.82t1.242-1.699q0-.465-.364-.742t-.98-.277q-1.31.019-2.533.83T13.95 12.75q0 .46.355.74t.97.28"/></svg>,
  "impersonate": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" fill-rule="evenodd" d="M2 1H1v6.72c0 2.824 1.112 5.445 2.973 7.382a12.1 12.1 0 0 1 .311-4.724l2.128-7.94L17 5.275V1zm5.473 3.275l-1.74 6.491a10.65 10.65 0 0 0 4.812 11.892l.245.147l.286-.005a10.65 10.65 0 0 0 10.112-7.893l1.74-6.49zm2.252 8.087a.75.75 0 0 1 1.448.388l1.45.388a2.25 2.25 0 0 0-4.347-1.164zm5.724 1.681a.75.75 0 1 1 1.45.388l1.448.389A2.25 2.25 0 0 0 14 13.655z" clip-rule="evenodd"/></svg>,

  "elipsis": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" fill-rule="evenodd" d="M18 14a2 2 0 1 1 0-4a2 2 0 0 1 0 4M6 14a2 2 0 1 1 0-4a2 2 0 0 1 0 4m6 0a2 2 0 1 1 0-4a2 2 0 0 1 0 4"/></svg>,

  "clickaction_www": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-www.png"/>,
  "clickaction_facebook": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-facebook.png"/>,
  "clickaction_viber": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-viber.png"/>,
  "clickaction_whatsapp": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-whatsapp.png"/>,
  "clickaction_line": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-line.png"/>,
  "clickaction_signal": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-signal.png"/>,
  "clickaction_telegram": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-telegram.png"/>,
  "clickaction_sms": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-sms.png"/>,
  "clickaction_email": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-email.png"/>,
  "clickaction_phone": (props) => <img width="16.8px" height="16.8px" src="https://sas.solv.technology/a/icons/solv-icon-clickaction-phone.png"/>,

  "sort_alpha_up": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path fill-rule="evenodd" d="M10.082 5.629L9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371zm1.57-.785L11 2.687h-.047l-.652 2.157z"/><path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645zm-8.46-.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999l.007-.007a.5.5 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707z"/></g></svg>,
  "sort_alpha_down": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path fill-rule="evenodd" d="M10.082 5.629L9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371zm1.57-.785L11 2.687h-.047l-.652 2.157z"/><path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999l.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/></g></svg>,

  "compass": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m7 17l3.2-6.8L17 7l-3.2 6.8zm5-5.9a.9.9 0 0 0-.9.9a.9.9 0 0 0 .9.9a.9.9 0 0 0 .9-.9a.9.9 0 0 0-.9-.9M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8a8 8 0 0 0-8-8"/></svg>,

  "section_expand": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.793 19.707a1 1 0 0 1 0-1.414L14.086 12L7.793 5.707a1 1 0 0 1 1.414-1.414l6.293 6.293a2 2 0 0 1 0 2.828l-6.293 6.293a1 1 0 0 1-1.414 0" clip-rule="evenodd"/></svg>,
  "section_collapse": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.707 16.207a1 1 0 0 1-1.414 0L12 9.914l-6.293 6.293a1 1 0 0 1-1.414-1.414L10.586 8.5a2 2 0 0 1 2.828 0l6.293 6.293a1 1 0 0 1 0 1.414" clip-rule="evenodd"/></svg>,

  "forbidden": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}><path fill="currentColor" fill-rule="evenodd" d="M15 8c0 3.87-3.13 7-7 7s-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7m-1 0c0 3.31-2.69 6-6 6c-1.48 0-2.83-.534-3.87-1.42l8.46-8.46a6 6 0 0 1 1.42 3.87zM3.4 11.87l8.46-8.46a6 6 0 0 0-3.87-1.42c-3.31 0-6 2.69-6 6c0 1.48.534 2.83 1.42 3.87z" clip-rule="evenodd"/></svg>,
  "not_found": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8v4m0 4.01l.01-.011M9 3H4v3m0 5v2m16-2v2M15 3h5v3M9 21H4v-3m11 3h5v-3"/></svg>,
  "server_error": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 100 100" {...props}><path fill="currentColor" d="M87.255 72.316c-2.248-2.246-5.832-2.318-8.118-.208l-9-9c2.459-3.77 3.894-8.27 3.894-13.107s-1.435-9.337-3.894-13.107l8.949-8.949c2.287 2.111 5.87 2.042 8.118-.207c2.306-2.3 2.329-6.017.054-8.293c-1.371-1.371-3.264-1.9-5.058-1.603c.33-1.82-.196-3.755-1.592-5.151c-2.274-2.275-5.985-2.252-8.291.055c-2.246 2.248-2.318 5.832-.208 8.118l-9.001 9.001a23.9 23.9 0 0 0-13.107-3.893a23.9 23.9 0 0 0-13.107 3.893l-8.95-8.95c2.11-2.286 2.04-5.869-.206-8.118c-2.305-2.304-6.018-2.328-8.293-.054c-1.372 1.372-1.901 3.266-1.604 5.059c-1.82-.33-3.756.197-5.152 1.591c-2.275 2.275-2.248 5.986.055 8.291c2.249 2.25 5.834 2.319 8.121.209l9 9c-2.46 3.77-3.894 8.27-3.894 13.107s1.434 9.337 3.894 13.107l-8.95 8.95c-2.286-2.11-5.869-2.04-8.118.206c-2.304 2.305-2.327 6.018-.054 8.293c1.372 1.372 3.266 1.901 5.059 1.604c-.33 1.82.197 3.756 1.591 5.152c2.275 2.275 5.986 2.248 8.291-.055c2.249-2.249 2.319-5.834.209-8.121l8.726-8.726v5.946a21.05 21.05 0 0 0 13.382 4.779a21.05 21.05 0 0 0 13.383-4.779V70.41l8.674 8.674c-2.111 2.287-2.043 5.871.206 8.119c2.301 2.306 6.018 2.329 8.293.054c1.371-1.371 1.9-3.265 1.603-5.058c1.82.331 3.755-.196 5.151-1.591c2.274-2.275 2.251-5.985-.056-8.292m-43.81-13.327a4.594 4.594 0 1 1 0-9.189c2.535 0 4.591 2.061 4.591 4.597s-2.057 4.592-4.591 4.592m13.111.067a4.592 4.592 0 0 1 0-9.184a4.593 4.593 0 1 1 0 9.184"/></svg>,

  "geopin": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7"/></svg>,

  // "country_flag": (props) => <img src={`https://sassets.solv.technology/flags/${props?.countryCode?.toLowerCase()}.svg`} width="16" height="16" {...props}/>,
  "country_flag": (props) => <img src={`https://flagcdn.com/16x12/${props.countryCode.toLowerCase()}.png`} alt="" style={{width: "16px", height: "12px", verticalAlign: 'middle'}}/>,
  "calling_code": (props) => <img src={`https://sassets.solv.technology/flags/${props?.countryCode?.toLowerCase()}.svg`} width="16" height="16" {...props}/>,

  "previous": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-width="2" d="m15 6l-6 6l6 6"/></svg>,
  "next": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-width="2" d="m9 6l6 6l-6 6"/></svg>,
  "continue": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-width="2" d="m9 6l6 6l-6 6"/></svg>,

  "owner": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M5 20v-2h14v2zm0-3.5L3.725 8.475q-.05 0-.113.013T3.5 8.5q-.625 0-1.062-.438T2 7t.438-1.062T3.5 5.5t1.063.438T5 7q0 .175-.038.325t-.087.275L8 9l3.125-4.275q-.275-.2-.45-.525t-.175-.7q0-.625.438-1.063T12 2t1.063.438T13.5 3.5q0 .375-.175.7t-.45.525L16 9l3.125-1.4q-.05-.125-.088-.275T19 7q0-.625.438-1.063T20.5 5.5t1.063.438T22 7t-.437 1.063T20.5 8.5q-.05 0-.112-.012t-.113-.013L19 16.5z"/></svg>,

  "info2": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0"/></svg>,

  "dashboard": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path fill="currentColor" d="M16.008 19q-.356 0-.586-.232q-.23-.233-.23-.576v-4.184q0-.356.232-.586q.233-.23.576-.23h4.185q.356 0 .585.233T21 14v4.185q0 .356-.232.585t-.576.23zM12 10.808q-.343 0-.575-.232T11.192 10V5.815q0-.355.233-.585T12 5h8.192q.344 0 .576.232t.232.576v4.185q0 .355-.232.585q-.233.23-.576.23zM3.808 19q-.343 0-.576-.232T3 18.192v-4.184q0-.356.232-.586t.576-.23H12q.343 0 .576.232t.232.576v4.185q0 .356-.232.585T12 19zm.007-8.192q-.355 0-.585-.232T3 10V5.815q0-.355.232-.585T3.808 5h4.185q.355 0 .585.232t.23.576v4.185q0 .355-.232.585q-.233.23-.576.23zm8.377-1H20V6h-7.808zM4 18h7.808v-3.808H4zm12.192 0H20v-3.808h-3.808zM4 9.808h3.808V6H4zm3.808 0" /></svg>,
  "about": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" fill="none" /><path fill="currentColor" d="M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2z" /></svg>,
  "about_app": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" fill="none" /><path fill="currentColor" d="M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2z" /></svg>,
  "articles": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 2048 2048"><path d="M0 0h2048v2048H0z" fill="none" /><path fill="currentColor" d="M1920 512v1408H768v-256H512v-256H256V0h731l256 256h421v256zm-896-128h165l-165-165zm256 896V512H896V128H384v1152zm256 256V384h-128v1024H640v128zm257-896h-129v1024H896v128h897z" />,</svg>,
  "help": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0" /><path d="m18 6l-3.525 3.525M6 18l3.525-3.525M6 6l3.525 3.525M18 18l-3.525-3.525m-4.95 0c-1.348-1.348-1.348-3.601 0-4.95m0 4.95c1.348 1.348 3.601 1.348 4.95 0m0 0c1.348-1.348 1.348-3.601 0-4.95m0 0c-1.348-1.348-3.601-1.348-4.95 0" /></g></svg>,
  "help_center": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0" /><path d="m18 6l-3.525 3.525M6 18l3.525-3.525M6 6l3.525 3.525M18 18l-3.525-3.525m-4.95 0c-1.348-1.348-1.348-3.601 0-4.95m0 4.95c1.348 1.348 3.601 1.348 4.95 0m0 0c1.348-1.348 1.348-3.601 0-4.95m0 0c-1.348-1.348-3.601-1.348-4.95 0" /></g></svg>,
  "app": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><g fill="none"><path d="M3 3h7v7H3zm11 11h7v7h-7zM3 14h7v7H3zm18.5-7.5a4 4 0 1 1-8 0a4 4 0 0 1 8 0" /><path stroke="currentColor" stroke-width="2" d="M3 3h7v7H3zm11 11h7v7h-7zM3 14h7v7H3zm18.5-7.5a4 4 0 1 1-8 0a4 4 0 0 1 8 0Z" /></g></svg>,
  "app_center": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><g fill="none"><path d="M3 3h7v7H3zm11 11h7v7h-7zM3 14h7v7H3zm18.5-7.5a4 4 0 1 1-8 0a4 4 0 0 1 8 0" /><path stroke="currentColor" stroke-width="2" d="M3 3h7v7H3zm11 11h7v7h-7zM3 14h7v7H3zm18.5-7.5a4 4 0 1 1-8 0a4 4 0 0 1 8 0Z" /></g></svg>,
  "home": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path fill="currentColor" d="m12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81zM12 3L2 12h3v8h6v-6h2v6h6v-8h3z" /></svg>,
  "send": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 15 16"><path d="M0 0h15v16H0z" fill="none" /><path fill="currentColor" d="M12.49 7.14L3.44 2.27c-.76-.41-1.64.3-1.4 1.13l1.24 4.34q.075.27 0 .54l-1.24 4.34c-.24.83.64 1.54 1.4 1.13l9.05-4.87a.98.98 0 0 0 0-1.72Z" /></svg>,
  "contact_us": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" fill="none" /><g fill="none" stroke="currentColor" stroke-width="1.5"><path d="M17 10.805c0-.346 0-.519.052-.673c.151-.448.55-.621.95-.803c.448-.205.672-.307.895-.325c.252-.02.505.034.721.155c.286.16.486.466.69.714c.943 1.146 1.415 1.719 1.587 2.35c.14.51.14 1.044 0 1.553c-.251.922-1.046 1.694-1.635 2.41c-.301.365-.452.548-.642.655a1.27 1.27 0 0 1-.721.155c-.223-.018-.447-.12-.896-.325c-.4-.182-.798-.355-.949-.803c-.052-.154-.052-.327-.052-.673zm-10 0c0-.436-.012-.827-.364-1.133c-.128-.111-.298-.188-.637-.343c-.449-.204-.673-.307-.896-.325c-.667-.054-1.026.402-1.41.87c-.944 1.145-1.416 1.718-1.589 2.35a2.94 2.94 0 0 0 0 1.553c.252.921 1.048 1.694 1.636 2.409c.371.45.726.861 1.363.81c.223-.018.447-.12.896-.325c.34-.154.509-.232.637-.343c.352-.306.364-.697.364-1.132z" /><path stroke-linecap="square" stroke-linejoin="round" d="M5 9c0-3.314 3.134-6 7-6s7 2.686 7 6" /><path stroke-linecap="round" stroke-linejoin="round" d="M19 17v.8c0 1.767-1.79 3.2-4 3.2h-2" /></g></svg>,
  "report_issue": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 16 16" {...props}><path d="M0 0h16v16H0z" fill="none" /><path fill="currentColor" d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.75.75 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0M9 9a1 1 0 1 1-2 0a1 1 0 0 1 2 0" /></svg>,
  "settings": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" fill="none" /><path fill="currentColor" d="m10.135 21l-.362-2.892q-.479-.145-1.035-.454q-.557-.31-.947-.664l-2.668 1.135l-1.865-3.25l2.306-1.739q-.045-.27-.073-.558q-.03-.288-.03-.559q0-.252.03-.53q.028-.278.073-.626L3.258 9.126l1.865-3.212L7.771 7.03q.448-.373.97-.673q.52-.3 1.013-.464L10.134 3h3.732l.361 2.912q.575.202 1.016.463t.909.654l2.725-1.115l1.865 3.211l-2.382 1.796q.082.31.092.569t.01.51q0 .233-.02.491q-.019.259-.088.626l2.344 1.758l-1.865 3.25l-2.681-1.154q-.467.393-.94.673t-.985.445L13.866 21zM11 20h1.956l.369-2.708q.756-.2 1.36-.549q.606-.349 1.232-.956l2.495 1.063l.994-1.7l-2.189-1.644q.125-.427.166-.786q.04-.358.04-.72q0-.38-.04-.72t-.166-.747l2.227-1.683l-.994-1.7l-2.552 1.07q-.454-.499-1.193-.935q-.74-.435-1.4-.577L13 4h-1.994l-.312 2.689q-.756.161-1.39.52q-.633.358-1.26.985L5.55 7.15l-.994 1.7l2.169 1.62q-.125.336-.175.73t-.05.82q0 .38.05.755t.156.73l-2.15 1.645l.994 1.7l2.475-1.05q.589.594 1.222.953q.634.359 1.428.559zm.973-5.5q1.046 0 1.773-.727T14.473 12t-.727-1.773t-1.773-.727q-1.052 0-1.776.727T9.473 12t.724 1.773t1.776.727M12 12" /></svg>,
  "credit_card": (props) => <svg xmlns="http://www.w3.org/2000/svg" width="1.12em" height="1.12em" viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" fill="none" /><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 9v-.8c0-1.12 0-1.68.218-2.108c.192-.377.497-.682.874-.874C4.52 5 5.08 5 6.2 5h11.6c1.12 0 1.68 0 2.107.218c.377.192.683.497.875.874c.218.427.218.987.218 2.105V9M3 9h18M3 9v6.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.987.218 2.105.218h11.606c1.118 0 1.677 0 2.104-.218c.377-.192.683-.498.875-.874c.218-.428.218-.986.218-2.104V9M6 15h4" /></svg>,
}

export function Icon(props) {
  const name = props.icon || props.name
  if (name in icons) {
    return icons[name](props)
  }
  else {
    return (<></>)
  }
}

export function ActionButton(props) {
  const {intl} = useIntlEx()
  const [confirming, setConfirming] = useState("confirm" in props)
  const [text, setText] = useState(booleanProp(props,"notext") || booleanProp(props,"buttononly") ? null : props.text || (props.msg ? intl.msg(props.msg) : props.name ? intl.msg(props.name) : props.action ? intl.msg(props.action) : ""))
  let addProps = {}
  const type = props.type?.toLowerCase() || "button"
  const icon = props.icon || props.name || props.action
  const disabled = booleanProp(props, "disabled")

  if (booleanProp(props, "hidden")) {
    return (<></>)
  }

  let onClick
  if (confirming) {
    onClick = () => {
      // log.debug(">>>Z: ActionButton: onClick called")
      setConfirming(false)
      setText(props.confirm ? props.confirm : text)
    }
  }
  else if (props.href) {
    onClick = () => window.location = props.href
  }
  else {
    onClick = props.onClick
  }

  return (
    "button" === type ? (
      <button type="button" key={props.key || props.id || props.name} id={props.id} className={`btn ${(props.flavor ? `btn-${props.flavor}` : "btn-secondary")} ${props.className ? props.className : ""}`} style={props.style} {...addProps} title={props.title} disabled={disabled} onClick={onClick}>
        {icon && <Icon name={icon}/>}
        {text && text}
      </button>
    ) : "file" === type ? (
      <label key={props.key || props.id || props.name} className={`btn ${(props.flavor ? `btn-${props.flavor}` : "btn-secondary")}`}>
        {icon && <Icon name={icon}/>}
        {text && text}
        <input id={props.id} type="file" accept={props.accept || "*/*"} onChange={props.onClick}/>
      </label>
    ) : (
      <></>
    )
  )

}

export function DropdownMenu(props) {
  const {intl} = useIntlEx()
  return (
    <>
      <button key={props.key} id={props.id || "dropdownMenuButton"} className="btn btn-secondary" style={{paddingInline: "0.25em"}} type="button" title={intl.msg("more_menu")} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <Icon name="more_menu"/>
      </button>
      <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        {props.children}
      </div>
    </>
  )
}

export function DropdownMenuItem(props) {
  const {intl} = useIntlEx()
  const name = props.item || props.name
  const icon = props.icon || name
  const text = props.text || intl.msg(props.msg || name)
  const addlAttrs = (props.href) ? {href: props.href} : {href: "#", onClick: props.onClick}

  const iconProps = {};

  for (const key in props) {
    if (key.startsWith('icon-')) {
      const newKey = key.substring(5);
      iconProps[newKey] = props[key];
    }
  }

  return (
    // <>
    //   {
    //     (booleanProp(props, "prefixWithDivider") || booleanProp(props, "withDivider")) &&
    //       <div className="dropdown-divider"></div>
    //   }
    //   <a className="dropdown-item" title={props.title || text} {...addlAttrs}>
    //     <Icon name={icon} {...iconProps}/>
    //     {text}
    //   </a>
    //   {
    //     booleanProp(props, "suffixWithDivider") &&
    //       <div className="dropdown-divider"></div>
    //   }
    // </>
    <>
      {
        (booleanProp(props, "prefixWithDivider") || booleanProp(props, "withDivider")) &&
          <div className="dropdown-divider"></div>
      }

      {
        "file" === props?.type ? (
          <label className="dropdown-item" title={props.title || text} style={{ cursor: 'pointer' }}
                 onClick={(e) => {
                   // Prevent dropdown from closing
                   e.stopPropagation();
                   e.preventDefault();
                   // Manually trigger the file input
                   // eslint-disable-next-line no-unused-expressions
                   document.getElementById(props.id)?.click();
                 }}
          >
            <Icon name={icon} {...iconProps}/>
            {text}
            <input id={props.id} type="file" accept={props.accept || "*/*"}
                   onChange={(e) => {
                     console.log("[FILE INPUT] onChange triggered");
                     console.log("[FILE INPUT] files:", e?.target?.files);
                     console.log("[FILE INPUT] handler exists:", !!(props.onClick || props.onChange));
                     const handler = props.onClick || props.onChange;
                     if (handler) {
                       handler(e);
                     } else {
                       console.error("[FILE INPUT] No handler found!");
                     }
                   }}
                   style={{display: "none"}}/>
          </label>
      ) : (
        <a className="dropdown-item" title={props.title || text}{...addlAttrs}>
          <Icon name={icon} {...iconProps}/>
          {text}
        </a>
      )}

      {
        booleanProp(props, "suffixWithDivider") &&
          <div className="dropdown-divider"></div>
      }
    </>
  )

}


export function DropdownMenuDivider(props) {
  return (
    <div className="dropdown-divider"></div>
  )
}

export function SelectDividerOption(props) {
  return (
    {
      value: "---",
      label: <div style={{height: "2px", borderTop: "1px solid var(--form-control-react-select-option-disabled-text-color)"}}></div>,
      isDisabled: true,
    }
  )
}

export function NumericInput({value, placeholder = "", min = null, max = Number.MAX_VALUE, decimals = 0, onChange, className, style, ...props}) {

  const [inputValue, setInputValue] = useState(null)
  // const [inputValue, setInputValue] = useState(formatNum(value))

  useEffect(() => {
    if (value !== null && value !== undefined && inputValue === null) {
      setInputValue(formatNum(value))
    }
  }, [value, inputValue])

  const numPat = useMemo(() => {
    const intPlaces = Math.trunc(Math.abs(max)).toString().length
    const decPlaces = decimals
    let res
    if (decPlaces && decPlaces > 0) {
      res = new RegExp(`^${isSigned(min) ? "(-)?" : ""}\\d{1,${intPlaces}}(\\.(\\d{0,${decPlaces}})?)?$`)
    }
    else {
      res = new RegExp(`^${isSigned(min) ? "(-)?" : ""}\\d{1,${intPlaces}}$`)
    }
    // console.log(`>>>Z: NumericInput: ${props.id}: useMemo: numPat=`, res)
    return res
  }, [min, max, decimals])

  function isSigned(n) {
    let r = false
    n = Number(n);
    if (n > 0) r = false;
    if (n < 0) r = true;
    // log.debug(">>>Z: NumericInput: isSigned=", r)
    return r;
  }

  // console.log(">>>Z: NumericInput: numericPattern=", numericPattern)

  function handleChange(e) {

    let v = e.target?.value
    let n = undefined

    if (booleanProp(props, "strict", true)) {
      switch (v.trim()) {
        case "":
          // log.debug(">>>Z: NumericInput: handleChange: empty=", v)
          if (null === min) {
            n = null
          }
          break
        case "-":
          // log.debug(">>>Z: NumericInput: handleChange: sign=", v)
          if (min >= 0) {
            v = undefined
          }
          break
        case ".":
          // log.debug(">>>Z: NumericInput: handleChange: dot=", v)
          if (decimals && decimals <= 0) {
            v = undefined
          }
          break
        default:
          // log.debug(">>>Z: NumericInput: handleChange: value=", v)
          if (numPat.test(v)) {
            n = parseNum(v)
            // if (n < min || n > max) {
            //   // console.log(`>>>Z: NumericInput: ${props.id}: `, n)
            //   v = undefined
            //   n = undefined
            // }
          }
          else {
            v = undefined
          }
          break
      }
    }
    else {
      n = parseNum()
    }

    if (v !== undefined) {
      setInputValue(v)
    }

    if (onChange && n !== undefined && !isNaN(n) && v !== undefined) {
      onChange(n, v)
    }

  }

  // const handleChange = useCallback((e) => {
  //
  //   let value = e.target?.value
  //
  //   if (!onChange) {
  //     return
  //   }
  //
  //   if (booleanProp(props, "strict", true)) {
  //     if ("" === value?.trim()) {
  //       onChange(null, value)
  //       setInputValue(value)
  //     }
  //     else if ("-" === value?.trim()) {
  //       if (isSigned(min)) {
  //         log.debug(">>>Z: NumericInput: value=-")
  //         setInputValue(value)
  //       }
  //     }
  //     else if ("." === value?.trim()) {
  //       if (decimals && decimals > 0) {
  //         log.debug(">>>Z: NumericInput: value=.")
  //         setInputValue(value)
  //       }
  //     }
  //     else if (numPat.test(value)) {
  //       onChange(parseNum(value), value)
  //       setInputValue(value)
  //     }
  //   }
  //   else {
  //     onChange(parseNum(value), value)
  //     setInputValue(value)
  //   }
  //
  // }, [onChange])

  function handleBlur(e) {
    const value = e.target?.value
    // console.log(">>>Z: NumericInput: handleBlur: value=", value)
    let v
    if ("" === value) {
      v = formatNum(value)
    }
    else {
      if (numPat.test(value)) {
        v = parseNum(value)
        if (!isNaN(v) && (min === null || v >= min) && v <= max) {
          v = formatNum(value)
          // console.log(">>>Z: NumericInput: 2 v=", v)
        }
        else {
          // v = toNum(min)
          v = formatNum("")
          // console.log(">>>Z: NumericInput: 3 v=", v)
        }
      }
      else {
        v = formatNum("")
      }
    }
    // console.log(">>>Z: NumericInput: 4 v=", v)
    setInputValue(v)
    // onChange(v)
  }

  function parseNum(v) {
    if ("string" === typeof(v) && v.endsWith(".")) {
      v = v + "0".repeat(decimals)
    }
    return (decimals && decimals > 0) ? Number.parseFloat(v) : Number.parseInt(v)
  }

  function formatNum(v) {
    if (v !== null && v !== undefined) {
      v = v.toString().trim()
      // console.log(">>>Z: NumericInput: formatNum 1:=", v)
      if ("" === v) {
        if (min === null) {
          return ""
        }
        else {
          v = min
        }
      }
      else if (v.endsWith(".")) {
        v = parseNum(v + "0".repeat(decimals))
      }
      else {
        v = parseNum(v)
      }
      // console.log(">>>Z: NumericInput: formatNum 2:=", v)
      v = decimals && decimals > 0 ? parseFloat(v) : parseInt(v)
      // console.log(">>>Z: NumericInput: formatNum 3:=", v)
      return v.toFixed(decimals)
    }
    else {
      // console.log(">>>Z: NumericInput: formatNum 4:=", "")
      return ""
    }
  }

  return (
    <input
      className={`talign-right ${className ? className : ""}`}
      style={style ? style : {}}
      type="text"
      inputMode={decimals && decimals > 0 ? "decimals" : "numeric"}
      pattern={numPat}
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
      autoComplete="off"
      {...props}
    />
  )

}


// export function NumericInput({value, placeholder = "", min = null, max = Number.MAX_VALUE, decimals = 0, onChange, className, style, ...props}) {
//
//   const [inputValue, setInputValue, inputValueRef] = useStateRef(undefined)
//
//   // log.debug(">>>Z: NumericInput: 0: value=", value, inputValue)
//
//   useEffect(() => {
//     log.debug(`>>>Z: NumericInput: ${props?.id}: useEffect[value]: value=`, value)
//     const c = inputValueRef.current
//     // log.debug(`>>>Z: NumericInput: ${props?.id}: useEffect[value] 1=`, value, `"${c?.toString()}"`)
//     // if (value !== null && inputValueRef.current === undefined) {
//     if (c === null || c === undefined || c === "") {
//       // log.debug(`>>>Z: NumericInput: ${props?.id}: useEffect[value] 2=`, value, c)
//       // setInputValue(value)
//       // setInputValue(formatNum(value))
//       setInputValue(formatNum(value))
//       // log.debug(`>>>Z: NumericInput: ${props?.id}: useEffect[value] 3=`, inputValueRef.current)
//     }
//     // log.debug(">>>Z: NumericInput: useEffect[value]: ", value, inputValue)
//   }, [value])
//
//   const numPat = useMemo(() => {
//     const intPlaces = Math.trunc(Math.abs(max)).toString().length
//     const decPlaces = decimals
//     let res
//     if (decPlaces && decPlaces > 0) {
//       res = new RegExp(`^${isSigned(min) ? "(-)?" : ""}\\d{1,${intPlaces}}(\\.(\\d{0,${decPlaces}})?)?$`)
//     }
//     else {
//       res = new RegExp(`^${isSigned(min) ? "(-)?" : ""}\\d{1,${intPlaces}}$`)
//     }
//     // console.log(">>>Z: NumericInput: intPlaces=, decPlaces=, numPat=", intPlaces, decPlaces, res, min, max)
//     return res
//   }, [min, max, decimals])
//
//   function isSigned(n) {
//     let r = false
//     n = Number(n);
//     if (n > 0) r = false;
//     if (n < 0) r = true;
//     // log.debug(">>>Z: NumericInput: isSigned=", r)
//     return r;
//   }
//
//   // console.log(">>>Z: NumericInput: numericPattern=", numericPattern)
//
//   const handleChange = useCallback((e) => {
//
//     let value = e.target?.value
//
//     if (!onChange) {
//       return
//     }
//
//     if (booleanProp(props, "strict", true)) {
//       if ("" === value?.trim()) {
//         onChange(null, value)
//         setInputValue(value)
//       }
//       else if ("-" === value?.trim()) {
//         if (isSigned(min)) {
//           log.debug(">>>Z: NumericInput: value=-")
//           setInputValue(value)
//         }
//       }
//       else if ("." === value?.trim()) {
//         if (decimals && decimals > 0) {
//           log.debug(">>>Z: NumericInput: value=.")
//           setInputValue(value)
//         }
//       }
//       else if (numPat.test(value)) {
//         onChange(parseNum(value), value)
//         setInputValue(value)
//       }
//     }
//     else {
//       onChange(parseNum(value), value)
//       setInputValue(value)
//     }
//
//   }, [onChange])
//
//   const handleBlur = (e) => {
//     const value = e.target?.value
//     console.log(">>>Z: NumericInput: handleBlur: value=", value)
//     let v
//     if ("" === value) {
//       v = formatNum(value)
//     }
//     else {
//       if (numPat.test(value)) {
//         v = parseNum(value)
//         if (!isNaN(v) && (min === null || v >= min) && v <= max) {
//           v = formatNum(value)
//           // console.log(">>>Z: NumericInput: 2 v=", v)
//         }
//         else {
//           // v = toNum(min)
//           v = formatNum("")
//           // console.log(">>>Z: NumericInput: 3 v=", v)
//         }
//       }
//       else {
//         v = formatNum("")
//       }
//     }
//     // console.log(">>>Z: NumericInput: 4 v=", v)
//     setInputValue(v)
//     // onChange(v)
//   }
//
//   function parseNum(v) {
//     if ("string" === typeof(v) && v.endsWith(".")) {
//       v = v + "0".repeat(decimals)
//     }
//     return (decimals && decimals > 0) ? Number.parseFloat(v) : Number.parseInt(v)
//   }
//
//   function formatNum(v) {
//     if (v !== null && v !== undefined) {
//       v = v.toString().trim()
//       console.log(">>>Z: NumericInput: formatNum 1:=", v)
//       if ("" === v) {
//         if (min === null) {
//           return ""
//         }
//         else {
//           v = min
//         }
//       }
//       else if (v.endsWith(".")) {
//         v = parseNum(v + "0".repeat(decimals))
//       }
//       else {
//         v = parseNum(v)
//       }
//       console.log(">>>Z: NumericInput: formatNum 2:=", v)
//       v = decimals && decimals > 0 ? parseFloat(v) : parseInt(v)
//       console.log(">>>Z: NumericInput: formatNum 3:=", v)
//       return v.toFixed(decimals)
//     }
//     else {
//       // console.log(">>>Z: NumericInput: formatNum 4:=", "")
//       return ""
//     }
//   }
//
//   return (
//     <input
//       className={`talign-right ${className ? className : ""}`}
//       style={style ? style : {}}
//       type="text"
//       inputMode={decimals && decimals > 0 ? "decimals" : "numeric"}
//       pattern={numPat}
//       value={inputValue}
//       onChange={handleChange}
//       onBlur={handleBlur}
//       placeholder={placeholder}
//       autoComplete="off"
//       {...props}
//     />
//   )
//
// }

// export function NumericInput({value, placeholder = "", min = null, max = Number.MAX_VALUE, decimals = 0, onChange, className, style, ...props}) {
//
//   const [inputValue, setInputValue] = useState(null)
//
//   useEffect(() => {
//     log.debug(">>>Z: NumericInput: useEffect: ", value)
//     setInputValue(formatNum(value))
//   }, [value])
//
//   const numPat = useMemo(() => {
//     const intPlaces = Math.trunc(Math.abs(max)).toString().length
//     const decPlaces = decimals
//     let res
//     if (decPlaces && decPlaces > 0) {
//       res = new RegExp(`^${isSigned(min || max) ? "(-)?" : ""}\\d{1,${intPlaces}}(\\.(\\d{0,${decPlaces}})?)?$`)
//     }
//     else {
//       res = new RegExp(`^${isSigned(min || max) ? "(-)?" : ""}\\d{1,${intPlaces}}$`)
//     }
//     // console.log(">>>Z: NumericInput: intPlaces=, decPlaces=, numPat=", intPlaces, decPlaces, res, min, max)
//     return res
//   })
//
//   // function countDecimalPlaces(v) {
//   //   const str = v?.toString()
//   //   if (str !== null) {
//   //     const dotIndex = str.indexOf(".");
//   //     if (dotIndex === -1) return 0;
//   //     const afterDot = str.slice(dotIndex + 1);
//   //     return afterDot.length;
//   //   }
//   //   else {
//   //     return 0
//   //   }
//   // }
//
//   function isSigned(n) {
//     n = Number(n);
//     if (n > 0) return false;
//     if (n < 0) return true;
//     return false;
//   }
//
//   // console.log(">>>Z: NumericInput: numericPattern=", numericPattern)
//
//   const handleChange = useCallback((e) => {
//     const value = e.target?.value
//     if (onChange) {
//       if (null === value || "" === value.trim()) {
//         if (null !== min) {
//           console.log(">>>Z: NumericInput: handleChange 2: value=", min)
//           onChange(parseNum(min))
//           setInputValue(min)
//         }
//         else {
//           console.log(">>>Z: NumericInput: handleChange 2: value=", "")
//           onChange(null)
//           // setInputValue(parseNum(min).toString())
//           setInputValue("")
//         }
//       }
//       else if (numPat.test(value)) {
//         console.log(">>>Z: NumericInput: handleChange 3: value=", value)
//         setInputValue(value)
//         onChange(parseNum(value))
//       }
//       else {
//         // console.log(">>>Z: toNum 0: no match")
//       }
//     }
//   }, [onChange])
//
//   const handleBlur = (e) => {
//     const value = e.target?.value
//     console.log(">>>Z: NumericInput: value=", value)
//     let v
//     if ("" === value) {
//       v = formatNum(value)
//     }
//     else {
//       if (numPat.test(value)) {
//         v = parseNum(value)
//         if (!isNaN(v) && (min === null || v >= min) && v <= max) {
//           v = formatNum(value)
//           // console.log(">>>Z: NumericInput: 2 v=", v)
//         }
//         else {
//           // v = toNum(min)
//           v = formatNum("")
//           // console.log(">>>Z: NumericInput: 3 v=", v)
//         }
//       }
//       else {
//         v = formatNum("")
//       }
//     }
//     // console.log(">>>Z: NumericInput: 4 v=", v)
//     setInputValue(v)
//     // onChange(v)
//   }
//
//   function parseNum(v) {
//     if ("string" === typeof(v) && v.endsWith(".")) {
//       v = v + "0".repeat(decimals)
//     }
//     return (decimals && decimals > 0) ? Number.parseFloat(v) : Number.parseInt(v)
//   }
//
//   function formatNum(v) {
//     if (v !== null && v !== undefined) {
//       v = v.toString().trim()
//       console.log(">>>Z: formatNum 1:=", v)
//       if ("" === v) {
//         if (min === null) {
//           return ""
//         }
//         else {
//           v = min
//         }
//       }
//       else if (v.endsWith(".")) {
//         v = parseNum(v + "0".repeat(decimals))
//       }
//       else {
//         v = parseNum(v)
//       }
//       // console.log(">>>Z: NumericInput: toNum 3: v=", v)
//       v = decimals && decimals > 0 ? parseFloat(v) : parseInt(v)
//       // console.log(">>>Z: NumericInput: toNum 4: v=", v)
//       return v.toFixed(decimals)
//     }
//     else {
//       return ""
//     }
//   }
//
//   return (
//     <input
//       className={`talign-right ${className ? className : ""}`}
//       style={style ? style : {}}
//       type="text"
//       inputMode={decimals && decimals > 0 ? "decimals" : "numeric"}
//       pattern={numPat}
//       value={inputValue}
//       onChange={handleChange}
//       onBlur={handleBlur}
//       placeholder={placeholder}
//       autoComplete="off"
//       {...props}
//     />
//   )
//
// }

// export function NumericInput({label, value, onChange, placeholder = '', integerLimit = null, /* New prop: maximum number of digits before the decimal point */ fractionalLimit = null, /* New prop: maximum number of digits after the decimal point */ ...props}) {
//
//   const [inputValue, setInputValue] = useState(value);
//
//   // Memoize the pattern generation to avoid recreating it on every render
//   const numericPattern = useMemo(() => {
//     let pattern = '^-?'; // Optional negative sign
//
//     // Integer part
//     if (integerLimit !== null && integerLimit > 0) {
//       pattern += `\\d{0,${integerLimit}}`; // Allows 0 to integerLimit digits
//     } else {
//       pattern += `\\d*`; // Allows any number of digits if no limit
//     }
//
//     // Fractional part (optional)
//     if (fractionalLimit !== null && fractionalLimit > 0) {
//       pattern += `(?:\\.\\d{0,${fractionalLimit}})?`; // Optional group for decimal and fractional digits
//     } else if (fractionalLimit === 0) {
//       pattern += `(?:\\.)?`; // Allow a decimal point, but no fractional digits (effectively integer only)
//     } else {
//       pattern += `(?:\\.\\d*)?`; // Allows any number of fractional digits if no limit
//     }
//
//     pattern += '$'; // End of string
//
//     return pattern;
//   }, [integerLimit, fractionalLimit]);
//
//   const handleChange = useCallback((event) => {
//     const newValue = event.target.value;
//
//     // Test the new value against the generated pattern
//     const regex = new RegExp(numericPattern);
//
//     if (regex.test(newValue) || newValue === '' || newValue === '-') {
//       setInputValue(newValue);
//       if (onChange) {
//         const parsedValue = parseFloat(newValue);
//         onChange(isNaN(parsedValue) ? null : parsedValue);
//       }
//     }
//   }, [onChange, numericPattern]);
//
//   const handleKeyPress = useCallback((event) => {
//     const charCode = event.which ? event.which : event.keyCode;
//     const char = String.fromCharCode(charCode);
//
//     // Allow digits, decimal point, negative sign, and control keys
//     if (
//       (charCode >= 48 && charCode <= 57) || // 0-9
//       charCode === 46 || // . (decimal point)
//       charCode === 45 || // - (negative sign)
//       charCode === 8 ||  // Backspace
//       charCode === 0     // For some arrow keys and other non-printable characters
//     ) {
//       // Further granular control for decimal and negative sign
//       const currentValue = event.target.value;
//
//       // Prevent multiple decimal points
//       if (charCode === 46 && currentValue.includes('.')) {
//         event.preventDefault();
//         return false;
//       }
//
//       // Prevent multiple negative signs, or negative sign not at the beginning
//       if (charCode === 45 && (currentValue.includes('-') || currentValue.length > 0)) {
//         event.preventDefault();
//         return false;
//       }
//
//       // Check integer limit during typing
//       if (integerLimit !== null && integerLimit > 0 && charCode >= 48 && charCode <= 57) {
//         const parts = currentValue.split('.');
//         const integerPart = parts[0].startsWith('-') ? parts[0].substring(1) : parts[0]; // Exclude negative sign for length check
//         if (parts.length === 1 && integerPart.length >= integerLimit) {
//           event.preventDefault();
//           return false;
//         }
//       }
//
//       // Check fractional limit during typing
//       if (fractionalLimit !== null && fractionalLimit >= 0 && charCode >= 48 && charCode <= 57) {
//         const parts = currentValue.split('.');
//         if (parts.length > 1 && parts[1].length >= fractionalLimit) {
//           event.preventDefault();
//           return false;
//         }
//       }
//
//       return true;
//     } else {
//       event.preventDefault();
//       return false;
//     }
//   }, [integerLimit, fractionalLimit]);
//
//   return (
//     <div>
//       {label && <label htmlFor={props.id || `numeric-input-${Math.random().toString(36).substr(2, 9)}`}>{label}</label>}
//       <input
//         id={props.id}
//         className={props.className}
//         type="text"
//         inputMode="numeric"
//         value={inputValue}
//         onChange={handleChange}
//         onKeyPress={handleKeyPress}
//         pattern={numericPattern} // Still useful for browser-level validation
//         placeholder={placeholder}
//         {...props}
//       />
//     </div>
//   );
// };
//
// export default NumericInput;

export function GridContainer(props) {
  if (booleanProp(props, "hidden")) {
    return (<></>)
  }
  let className = "form-grid-container"
  // if (props.nowrap) {
  //   className = `${className} flex-nowrap`
  // }
  // if (props.nogutters) {
  //   className = `${className} no-gutters`
  // }
  if (props.className) {
    className = `${className} ${props.className}`
  }
  return (
    <div className={className}>{props.children}</div>
  )
}

export function GridElement(props) {
  if (booleanProp(props, "hidden")) {
    return (<></>)
  }
  let className = "form-grid-element"
  // if (props.nowrap) {
  //   className = `${className} flex-nowrap`
  // }
  // if (props.nogutters) {
  //   className = `${className} no-gutters`
  // }
  if (props.className) {
    className = `${className} ${props.className}`
  }
  return (
    <div className={className}>{props.children}</div>
  )
}

export function Frag(props) {
  if (booleanProp(props, "hidden")) {
    return (<></>)
  }
  else {
    return (props.children)
  }
}

export function BlurredText({ children, wait = 500 }) {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, wait);

    return () => clearTimeout(timer);
  }, [wait]);

  // Define the animation styles inline
  const blurEffectStyle = {
    animation: `blurToClear 2s forwards`,
  };

  const blurKeyframes = `
    @keyframes blurToClear {
      0% {
        filter: blur(5px);
      }
      100% {
        filter: blur(0);
      }
    }
  `;

  useEffect(() => {
    const styleSheet = document.styleSheets[0];
    styleSheet.insertRule(blurKeyframes, styleSheet.cssRules.length);
  }, []);

  return (
    <div>
      <style>{blurKeyframes}</style> {/* Insert the keyframes directly */}
      <h1 style={isVisible ? blurEffectStyle : {}}>{children}</h1>
    </div>
  );
}

export function PhoneInput({id, value = "", countryCode, onChange, disabled = false, maxLength = 80, maxWidth = "400px"}) {

  const {intl} = useIntlEx()

  const {callingCodes, findCallingCode, findCallingCodeByCountryCode} = useCallingCode()

  const normalizeCode = (code) => "+" + onlyDigits(code);

  const defaultCode = normalizeCode(findCallingCodeByCountryCode(countryCode).callingCode);

  const knownCodeDigits = React.useMemo(
    () =>
      [...new Set(callingCodes.map((c) => onlyDigits(c.callingCode)))].sort(
        (a, b) => b.length - a.length
      ),
    [callingCodes]
  );

  const groupedCodes = React.useMemo(() => {
    const groups = new Map();
    callingCodes.forEach(c => {
      const key = normalizeCode(c.callingCode);
      if (!groups.has(key)) groups.set(key, { code: key, countries: [] });
      groups.get(key).countries.push({code: c.countryCode, name: c.countryCode});
    });
    return [...groups.values()];
  }, [callingCodes]);

  function parsePhone(value) {
    const raw = String(value == null ? "" : value).trim();
    const digits = onlyDigits(raw);

    if (!raw.startsWith("+")) {
      return { code: defaultCode, number: digits };
    }

    const match = knownCodeDigits.find((c) => digits.startsWith(c));
    const codeDigits = match !== undefined ? match : digits.slice(0, 3);

    return {
      code: codeDigits ? "+" + codeDigits : defaultCode,
      number: digits.slice(codeDigits.length),
    };
  }

  const { code, number} = parsePhone(value);

  const emit = (newCode, newNumber) => {
    if (onChange) onChange({target: {value: newCode + newNumber}});
  };

  const handleCodeSelect = (e, cc) => {
    e.preventDefault(); // stop the "#" href from changing the URL
    emit(normalizeCode(cc), number);
  };

  const handleChange = (e) => {
    emit(code, onlyDigits(e.target.value));
  };

  const handlePaste = (e) => {
    const text = (e.clipboardData || window.clipboardData).getData("text");
    const pasted = String(text || "").trim();
    if (!pasted) return;

    e.preventDefault();

    // Full international number (+xxyyy...): replace the whole value and
    // select the matching calling code.
    if (pasted.startsWith("+")) {
      const parsed = parsePhone(pasted);
      emit(parsed.code, parsed.number.slice(0, maxLength));
      return;
    }

    // Local number: keep the current calling code and insert the digits at
    // the cursor, replacing any selected text.
    const input = e.target;
    const start = input.selectionStart != null ? input.selectionStart : number.length;
    const end = input.selectionEnd != null ? input.selectionEnd : number.length;
    const merged = number.slice(0, start) + onlyDigits(pasted) + number.slice(end);
    emit(code, merged.slice(0, maxLength));
  };

  return (
    <div className="input-group" style={{ maxWidth }}>
      <div className="input-group-prepend">
        <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled={disabled}>
          {code}
        </button>
        <div
          className="dropdown-menu"
          style={{ maxHeight: "250px", overflowY: "auto" }}
        >
          {groupedCodes.map(({ code: c, countries }) => {
            const names = countries.map(x => intl.msg(`country_${x.code}`)).join(" / ")
            return (
              <a key={c} className="dropdown-item" href="#" title={names} aria-label={`${c} ${names}`} onClick={(e) => handleCodeSelect(e, c)}>
                {c} {names}
              </a>
            );
          })}
        </div>
      </div>
      <input id={id} type="text" inputMode="numeric" className="form-control" maxLength={maxLength} value={number} disabled={disabled} onChange={handleChange} onPaste={handlePaste}/>
    </div>
  );
}

export const PhoneInputOld = React.forwardRef(({ callingCode, onChange, value, ...props }, ref) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    const sanitized = sanitizePhoneInput(newValue);

    // Create a new event with the sanitized value
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: sanitized
      }
    };

    if (onChange) {
      onChange(syntheticEvent);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    const sanitized = sanitizePhoneInput(pastedText);

    const target = e.target;
    const start = target.selectionStart;
    const end = target.selectionEnd;
    const currentValue = target.value || '';

    // Insert sanitized text at cursor position
    const newValue = currentValue.substring(0, start) + sanitized + currentValue.substring(end);
    const finalValue = sanitizePhoneInput(newValue);

    // Create synthetic event
    const syntheticEvent = {
      ...e,
      target: {
        ...target,
        value: finalValue
      }
    };

    if (onChange) {
      onChange(syntheticEvent);
    }

    // Set cursor position after pasted content
    setTimeout(() => {
      target.selectionStart = target.selectionEnd = start + sanitized.length;
    }, 0);
  };

  const sanitizePhoneInput = (input) => {
    if (!input) return '';

    // Check if input starts with +
    const hasPlus = input.startsWith('+');

    // Remove all non-digits except + at the start
    let sanitized = input.replace(/[^\d+]/g, '');

    // Ensure + only appears at the start
    if (hasPlus) {
      sanitized = '+' + sanitized.replace(/\+/g, '');
    } else {
      sanitized = sanitized.replace(/\+/g, '');
    }

    return sanitized;
  };

  const handleKeyDown = (e) => {
    const { key, target } = e;
    const cursorPos = target.selectionStart;
    const currentValue = target.value || '';

    // Allow control keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'].includes(key)) {
      return;
    }

    // Allow Ctrl/Cmd combinations
    if (e.ctrlKey || e.metaKey) {
      return;
    }

    // Allow + only at the beginning when field is empty or when replacing all content
    if (key === '+') {
      if (cursorPos !== 0 || (currentValue && target.selectionStart !== target.selectionEnd && target.selectionEnd !== currentValue.length)) {
        e.preventDefault();
      }
      return;
    }

    // Allow only digits
    if (!/^\d$/.test(key)) {
      e.preventDefault();
    }
  };

  // Add calling code if needed
  const getFinalValue = () => {
    if (!value) return '';

    const stringValue = String(value);

    // If value doesn't start with + and callingCode is provided, prepend it
    if (!stringValue.startsWith('+') && callingCode) {
      return `+${callingCode}${stringValue}`;
    }

    return stringValue;
  };

  return (
    <input
      ref={ref}
      className={`form-control ${props.className || ""}`}
      type="text"
      value={getFinalValue()}
      onChange={handleChange}
      onPaste={handlePaste}
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
});

export function getDocumentSkinElements() {
  return document.getElementById("main-container") || document.documentElement;
}

export function getWindowMode() {
  return window.getComputedStyle(getDocumentSkinElements()).getPropertyValue("--mode")?.trim()?.toLowerCase() || "dark"
}

export function transformLogoUrl(brandId, logoUrl) {
  if (!brandId || !logoUrl) {
    return null
  }
  const mode = getWindowMode()
  const u = logoUrl.trim().replaceAll("\"", "").replaceAll("{brandId}", brandId.toLowerCase()).replaceAll("{mode}", mode.toLowerCase())
  return ({
    colorUrl: u.replaceAll("{color}", "color"),
    monoUrl: u.replaceAll("{color}", "mono"),
  })
}

// export function getLogoInfo() {
//   const skinEl = getDocumentSkinElements()
//   let logoUrl = window.getComputedStyle(skinEl).getPropertyValue("--app-logo-uri")
//   let mode = window.getComputedStyle(skinEl).getPropertyValue("--mode")?.trim()?.toLowerCase() || "dark"
//   logoUrl = logoUrl.trim().replaceAll("\"", "").replaceAll("{mode}", mode.toLowerCase())
//   const aspectRatio = parseFloat(window.getComputedStyle(skinEl).getPropertyValue("--app-logo-aspect-ratio")?.replaceAll("\"", "")?.split(/\s*x\s*/i) || 1)
//   log.debug(">>>Z: getLogoInfo: ",aspectRatio)
//   return ({
//     colorUrl: logoUrl.replaceAll("{color}", "color"),
//     monoUrl: logoUrl.replaceAll("{color}", "mono"),
//     size: [aspectRatio * 14, 14],
//     margin: window.getComputedStyle(skinEl).getPropertyValue("--app-logo-margin")?.replaceAll("\"", "")
//   })
//
// }

export function AppLogo(props) {

  const {env, prefs} = useSolv()

  // const values = getPropertyComputedValue(["--app-logo-ic-uri", "--app-logo-sm-uri", "--app-logo-sm-aspect-ratio", "--app-logo-sm-margins", "--app-logo-md-uri", "--app-logo-md-aspect-ratio", "--app-logo-md-margins", "--app-logo-lg-uri", "--app-logo-lg-aspect-ratio", "--app-logo-lg-margins"])

  // log.debug("AppLogo: values=", values)

  const logoUrl = env.logoUrl

  // const mode = prefs.theme.mode || "light"
  // const size = props.size?.toLowerCase() || "md"
  // const logoUrl = env[`logo${capFirst(mode)}Url`]
  //
  //
  // const logoUrl = env.logoUrl.trim().replaceAll("\"", "").replaceAll("{mode}", mode.toLowerCase()).replaceAll("{size}", size.toLowerCase())

  let styles = {
    width: (props.width ? `${props.width}px` : "auto"),
    height: (props.height ? `${props.height}px` : "auto"),
  }

  if ("menu" === props.place && env.logoMenuStyles) {
    // log.debug(">>>Z: logo: menuStyles=", env.logoMenuStyles)
    styles = {...styles, ...cssStringToObject(env.logoMenuStyles)}
    // log.debug(">>>Z: logo: styles=", styles)
  }

  return (
    <img src={logoUrl} style={styles}/>
  )

}

export function AppCopyrightNotice(props) {

  const {env} = useSolv()
  const {intl} = useIntlEx()

  function getServerYear() {
    return ""
    if (!env.serverTime) {
      return ""
    }
    try {
      const date = new Date(env.serverTime)
      // if (env.PLATFORM_ID === env.brandId) {
      //   return `2020 - ${date.getFullYear()}`
      // }
      // else {
        return `${date.getFullYear()}`
      // }
    }
    catch (e) {
      return ""
    }
  }

  return (
    <div><span className="d-md-up">Copyright </span>© {getServerYear()} <a className="text-link" href={env.entityUrl} title={env.entity__Url} target="_blank">{env.entityName}</a>.
      {/*{intl.msg("all_rights_reserverd")}.*/}
    {/*{*/}
    {/*  (env.ENTITY_NAME && env.BRAND_ENTITY_NAME !== env.entityName) &&*/}
    {/*    <> • <a className="text-link" href={env.BRAND_ENTITY_URL} title={env.BRAND_ENTITY__URL} target="_blank">{env.BRAND_ENTITY_NAME}</a></>*/}
    {/*}*/}
    </div>
  )

}

export function Div(props) {

  if (booleanProp(props, "hidden") === true) {
    return <></>
  }
  else {
    return (
      <div {...props}>
        {props.children}
      </div>
    )
  }

}

export function Span(props) {

  if (booleanProp(props, "hidden") === true) {
    return <></>
  }
  else {
    return (
      <span {...props}>
        {props.children}
      </span>
    )
  }

}

export function Button(props) {

  if (booleanProp(props, "hidden") === true) {
    return <></>
  }
  else {
    return (
      <button {...props}>
        {props.children}
      </button>
    )
  }

}

export function OtpInput({ length = 6, onChange, value = '' }) {
  const [otp, setOtp] = useState(Array(length).fill(''));
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [filledAll, setFilledAll] = useState(false);
  const inputRefs = useRef([]);
  const selectingAll = useRef(false);


  // Initialize refs array
  useEffect(() => {
    inputRefs.current = inputRefs.current.slice(0, length);
  }, [length]);

  // Sync with external value prop
  useEffect(() => {
    if (value) {
      const digits = value.slice(0, length).split('');
      const newOtp = [...Array(length).fill(''), ...digits].slice(-length);
      setOtp(newOtp);
    }
  }, [value, length]);

  const focusInput = (index) => {
    if (inputRefs.current[index]) {
      inputRefs.current[index].focus();
    }
  };

  const handleChange = (index, e) => {
    const val = e.target.value.toUpperCase();
    if (val && !/^[A-Z0-9]$/.test(val)) return;

    const newOtp = [...otp];
    newOtp[index] = val;
    setOtp(newOtp);

    if (val && index < length - 1) focusInput(index + 1);

    const otpString = newOtp.join("");
    const allFilled = newOtp.every((d) => d !== "");
    setFilledAll(allFilled);
    if (allFilled && onChange) onChange(otpString);
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        focusInput(index - 1);
      } else if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
        setFilledAll(false);
      }
      e.preventDefault();
    }
    if (e.key === "ArrowLeft" && index > 0) focusInput(index - 1);
    if (e.key === "ArrowRight" && index < length - 1) focusInput(index + 1);

    // Select all inputs on Cmd+A (Mac) or Ctrl+A (Windows/Linux)
    if (e.key === "a" && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      selectingAll.current = true;
      inputRefs.current.forEach((el) => el?.select());
      selectingAll.current = false;
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").toUpperCase();
    const validChars = pastedData.match(/[A-Z0-9]/g);
    if (validChars) {
      const newOtp = [...otp];
      validChars.slice(0, length).forEach((char, i) => (newOtp[i] = char));
      setOtp(newOtp);
      const nextEmpty = newOtp.findIndex((d) => d === "");
      focusInput(nextEmpty !== -1 ? nextEmpty : length - 1);
      const allFilled = newOtp.every((d) => d !== "");
      setFilledAll(allFilled);
      if (allFilled && onChange) onChange(newOtp.join(""));
    }
  };

  const handleFocus = (index) => {
    setFocusedIndex(index);
    if (inputRefs.current[index]) inputRefs.current[index].select();
  };

  const handleBlur = () => setFocusedIndex(null);


  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      {otp.map((digit, index) => (
        <input
          className="form-control"
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          inputMode="text"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          onFocus={() => handleFocus(index)}
          onBlur={handleBlur}
          autoComplete="no"
          style={{textAlign: 'center', fontSize: '24px', fontWeight: '600', outline: 'none', transition: 'border-color 0.2s', textTransform: 'uppercase'}}
        />
      ))}
    </div>
  );
}
